/*
 * main.js - Shrine PRO (version saneada)
 * Desofuscado y limpiado. Eliminado: licencia remota a dominio .mars,
 * bomba de tiempo (fecha fija + 27 dias), sabotaje body.innerHTML, lectura del token,
 * huella de entorno en localStorage. Ver informe de auditoria (SEC-02..SEC-08, SEC-14, SEC-18).
 */
const ON_CHANGE_DEBOUNCE_TIMER = 300;
const currentDate = new Date();
const PUB_SUB_EVENTS = {
  cartUpdate: "cart-update",
  quantityUpdate: "quantity-update",
  variantChange: "variant-change"
};
let subscribers = {};
function subscribe(_0x376b21, _0x20b568) {
  if (subscribers[_0x376b21] === undefined) {
    subscribers[_0x376b21] = [];
  }
  subscribers[_0x376b21] = [...subscribers[_0x376b21], _0x20b568];
  return function _0x33238a() {
    subscribers[_0x376b21] = subscribers[_0x376b21].filter(_0x466cd1 => {
      return _0x466cd1 !== _0x20b568;
    });
  };
}
;
function publish(_0x5e90c7, _0x6858b2) {
  if (subscribers[_0x5e90c7]) {
    subscribers[_0x5e90c7].forEach(_0x260111 => {
      _0x260111(_0x6858b2);
    });
  }
}
class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", _0x4b295f => {
      _0x4b295f.preventDefault();
      const _0x268cd3 = this.closest("cart-items") || this.closest("cart-drawer-items");
      if (this.clearCart) {
        _0x268cd3.clearCart();
      } else {
        _0x268cd3.updateQuantity(this.dataset.index, 0);
      }
    });
  }
}
customElements.define("cart-remove-button", CartRemoveButton);
class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement = document.getElementById("shopping-cart-line-item-status") || document.getElementById("CartDrawer-LineItemStatus");
    this.secondCartItems = document.querySelector("cart-drawer-items");
    const _0x54e5ae = debounce(_0x2ccd83 => {
      this.onChange(_0x2ccd83);
    }, ON_CHANGE_DEBOUNCE_TIMER);
    this.addEventListener("change", _0x54e5ae.bind(this));
  }
  cartUpdateUnsubscriber = undefined;
  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, _0xd5e831 => {
      if (_0xd5e831.source === "cart-items") {
        return;
      }
      this.onCartUpdate();
    });
  }
  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }
  onChange(_0x15473b) {
    this.updateQuantity(_0x15473b.target.dataset.index, _0x15473b.target.value, document.activeElement.getAttribute("name"));
  }
  onCartUpdate() {
    fetch("/cart?section_id=main-cart-items").then(_0x2698cc => _0x2698cc.text()).then(_0x34e225 => {
      const _0x4e5a45 = new DOMParser().parseFromString(_0x34e225, "text/html");
      const _0x506976 = _0x4e5a45.querySelector("cart-items");
      this.innerHTML = _0x506976.innerHTML;
    }).catch(_0x50a272 => {
      console.error(_0x50a272);
    });
  }
  updateCart() {
    const _0x52be56 = JSON.stringify({
      sections: this.getSectionsToRender().map(_0x5f3aa4 => _0x5f3aa4.section),
      sections_url: window.location.pathname
    });
    fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: _0x52be56
    }).then(_0x25fe5c => _0x25fe5c.json()).then(_0x63825d => {
      this.classList.toggle("is-empty", _0x63825d.item_count === 0);
      this.getSectionsToRender().forEach(_0x53c82d => {
        const _0xe89b8f = document.getElementById(_0x53c82d.id).querySelector(_0x53c82d.selector) || document.getElementById(_0x53c82d.id);
        _0xe89b8f.innerHTML = this.getSectionInnerHTML(_0x63825d.sections[_0x53c82d.section], _0x53c82d.selector);
      });
    }).catch(_0x4a9add => {
      console.error(_0x4a9add);
    });
  }
  getSectionsToRender() {
    return [{
      id: "main-cart-items",
      section: document.getElementById("main-cart-items").dataset.id,
      selector: ".js-contents"
    }, {
      id: "cart-icon-bubble",
      section: "cart-icon-bubble",
      selector: ".shopify-section"
    }, {
      id: "cart-live-region-text",
      section: "cart-live-region-text",
      selector: ".shopify-section"
    }, {
      id: "main-cart-footer",
      section: document.getElementById("main-cart-footer").dataset.id,
      selector: ".js-contents"
    }];
  }
  async updateQuantity(_0x13e1d6, _0x2b0f6c, _0xdaebda) {
    this.enableLoading(_0x13e1d6);
    const _0x5b64c9 = JSON.stringify({
      line: _0x13e1d6,
      quantity: _0x2b0f6c,
      sections: this.getSectionsToRender().map(_0x5b9e74 => _0x5b9e74.section),
      sections_url: window.location.pathname
    });
    try {
      const _0x47acf4 = await fetch("" + routes.cart_change_url, {
        ...fetchConfig(),
        ...{
          body: _0x5b64c9
        }
      });
      const _0x20bfe3 = await _0x47acf4.text();
      const _0x2c7c15 = JSON.parse(_0x20bfe3);
      const _0xc1722d = document.getElementById("Quantity-" + _0x13e1d6) || document.getElementById("Drawer-quantity-" + _0x13e1d6);
      const _0x3a3cdb = document.querySelectorAll(".cart-item");
      if (_0x2c7c15.errors) {
        _0xc1722d.value = _0xc1722d.getAttribute("value");
        this.updateLiveRegions(_0x13e1d6, _0x2c7c15.errors);
        return;
      }
      if (!_0x2c7c15.sections) {
        const _0x32bc69 = await fetch(routes.cart_url + "?sections=" + this.getSectionsToRender().map(_0x4e219c => _0x4e219c.section).join(","));
        _0x2c7c15.sections = await _0x32bc69.json();
      }
      this.classList.toggle("is-empty", _0x2c7c15.item_count === 0);
      const _0x5d3415 = document.querySelector("cart-drawer");
      const _0x5c229d = document.getElementById("main-cart-footer");
      if (_0x5c229d) {
        _0x5c229d.classList.toggle("is-empty", _0x2c7c15.item_count === 0);
      }
      if (_0x5d3415) {
        _0x5d3415.classList.toggle("is-empty", _0x2c7c15.item_count === 0);
      }
      this.getSectionsToRender().forEach(_0x2314d4 => {
        const _0x50c1dd = document.getElementById(_0x2314d4.id).querySelector(_0x2314d4.selector) || document.getElementById(_0x2314d4.id);
        _0x50c1dd.innerHTML = this.getSectionInnerHTML(_0x2c7c15.sections[_0x2314d4.section], _0x2314d4.selector);
      });
      const _0x2833b6 = _0x2c7c15.items[_0x13e1d6 - 1] ? _0x2c7c15.items[_0x13e1d6 - 1].quantity : undefined;
      let _0x456e62 = "";
      if (_0x3a3cdb.length === _0x2c7c15.items.length && _0x2833b6 !== parseInt(_0xc1722d.value)) {
        if (typeof _0x2833b6 === "undefined") {
          _0x456e62 = window.cartStrings.error;
        } else {
          _0x456e62 = window.cartStrings.quantityError.replace("[quantity]", _0x2833b6);
        }
      }
      this.updateLiveRegions(_0x13e1d6, _0x456e62);
      const _0x402657 = document.getElementById("CartItem-" + _0x13e1d6) || document.getElementById("CartDrawer-Item-" + _0x13e1d6);
      if (_0x402657 && _0x402657.querySelector("[name=\"" + _0xdaebda + "\"]")) {
        if (_0x5d3415) {
          trapFocus(_0x5d3415, _0x402657.querySelector("[name=\"" + _0xdaebda + "\"]"));
        } else {
          _0x402657.querySelector("[name=\"" + _0xdaebda + "\"]").focus();
        }
      } else if (_0x2c7c15.item_count === 0 && _0x5d3415) {
        trapFocus(_0x5d3415.querySelector(".drawer__inner-empty"), _0x5d3415.querySelector("a"));
      } else if (document.querySelector(".cart-item") && _0x5d3415) {
        trapFocus(_0x5d3415, document.querySelector(".cart-item__name"));
      }
      if (_0x5d3415) {
        _0x5d3415.checkForClear();
        const _0xddbc9a = _0x5d3415.querySelector("countdown-timer");
        if (_0xddbc9a) {
          _0xddbc9a.playTimer();
        }
        if (_0x5d3415.querySelector("cart-drawer-gift")) {
          _0x5d3415.checkForClear();
          let _0xd4fc8d = [];
          let _0x4465e8 = [];
          _0x5d3415.querySelectorAll("cart-drawer-gift").forEach(_0x2bcbcd => {
            if (_0x2bcbcd.getUpdateRequired()) {
              if (_0x5d3415.querySelector(".cart-item--product-" + _0x2bcbcd.dataset.handle)) {
                if (_0x2bcbcd.dataset.selected === "false") {
                  _0x4465e8.push(_0x2bcbcd);
                }
              } else if (_0x2bcbcd.dataset.selected === "true") {
                _0xd4fc8d.push(_0x2bcbcd);
              }
            }
          });
          if (_0x4465e8.length > 0) {
            _0x4465e8[0].removeFromCart();
          } else if (_0xd4fc8d.length > 0) {
            _0xd4fc8d[0].addToCart();
          }
        }
      }
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: "cart-items"
      });
    } catch (_0xd9d3ec) {
      this.querySelectorAll(".loading-overlay").forEach(_0xeba568 => _0xeba568.classList.add("hidden"));
      const _0x37a11b = document.getElementById("cart-errors") || document.getElementById("CartDrawer-CartErrors");
      _0x37a11b.textContent = window.cartStrings.error;
    } finally {
      this.disableLoading(_0x13e1d6);
      if (this.secondCartItems && this.secondCartItems.updateCart) {
        this.secondCartItems.updateCart();
      }
      const _0x31e235 = new CustomEvent("cartQuantityUpdated", {
        detail: {
          handle: "handle"
        }
      });
      document.dispatchEvent(_0x31e235);
    }
  }
  updateLiveRegions(_0x46c1ca, _0x5c43d3) {
    const _0x4a42ca = document.getElementById("Line-item-error-" + _0x46c1ca) || document.getElementById("CartDrawer-LineItemErrork-" + _0x46c1ca);
    if (_0x4a42ca) {
      _0x4a42ca.querySelector(".cart-item__error-text").innerHTML = _0x5c43d3;
    }
    this.lineItemStatusElement.setAttribute("aria-hidden", true);
    const _0x1e8f7e = document.getElementById("cart-live-region-text") || document.getElementById("CartDrawer-LiveRegionText");
    _0x1e8f7e.setAttribute("aria-hidden", false);
    setTimeout(() => {
      _0x1e8f7e.setAttribute("aria-hidden", true);
    }, 1000);
  }
  getSectionInnerHTML(_0x4f5d94, _0x5219e9) {
    return new DOMParser().parseFromString(_0x4f5d94, "text/html").querySelector(_0x5219e9).innerHTML;
  }
  enableLoading(_0x44b8ba) {
    const _0x5254fa = document.getElementById("main-cart-items") || document.getElementById("CartDrawer-CartItems");
    _0x5254fa.classList.add("cart__items--disabled");
    const _0x27cb71 = this.querySelectorAll("#CartItem-" + _0x44b8ba + " .loading-overlay");
    const _0x3c9eba = this.querySelectorAll("#CartDrawer-Item-" + _0x44b8ba + " .loading-overlay");
    [..._0x27cb71, ..._0x3c9eba].forEach(_0x33807d => _0x33807d.classList.remove("hidden"));
    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute("aria-hidden", false);
  }
  disableLoading(_0x5c0b27) {
    const _0x24edaf = document.getElementById("main-cart-items") || document.getElementById("CartDrawer-CartItems");
    _0x24edaf.classList.remove("cart__items--disabled");
    const _0x4546dd = this.querySelectorAll("#CartItem-" + _0x5c0b27 + " .loading-overlay");
    const _0xfff61a = this.querySelectorAll("#CartDrawer-Item-" + _0x5c0b27 + " .loading-overlay");
    _0x4546dd.forEach(_0x2ed6e5 => _0x2ed6e5.classList.add("hidden"));
    _0xfff61a.forEach(_0x508fa6 => _0x508fa6.classList.add("hidden"));
  }
  clearCart() {
    const _0x2aa945 = JSON.stringify({
      sections: this.getSectionsToRender().map(_0x3ba5d7 => _0x3ba5d7.section),
      sections_url: window.location.pathname
    });
    fetch("" + routes.cart_clear_url, {
      ...fetchConfig(),
      ...{
        body: _0x2aa945
      }
    }).then(_0x315645 => {
      return _0x315645.text();
    }).then(_0x1a008c => {
      const _0x1c8ff7 = JSON.parse(_0x1a008c);
      this.classList.add("is-empty");
      const _0x4692b5 = document.querySelector("cart-drawer");
      const _0x449554 = document.getElementById("main-cart-footer");
      if (_0x449554) {
        _0x449554.classList.add("is-empty");
      }
      if (_0x4692b5) {
        _0x4692b5.classList.add("is-empty");
      }
      this.getSectionsToRender().forEach(_0x1be398 => {
        const _0x188d89 = document.getElementById(_0x1be398.id).querySelector(_0x1be398.selector) || document.getElementById(_0x1be398.id);
        _0x188d89.innerHTML = this.getSectionInnerHTML(_0x1c8ff7.sections[_0x1be398.section], _0x1be398.selector);
      });
      if (_0x4692b5) {
        trapFocus(_0x4692b5.querySelector(".drawer__inner-empty"), _0x4692b5.querySelector("a"));
      }
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: "cart-items"
      });
    }).catch(() => {
      this.querySelectorAll(".loading-overlay").forEach(_0x520be5 => _0x520be5.classList.add("hidden"));
      const _0x830366 = document.getElementById("cart-errors") || document.getElementById("CartDrawer-CartErrors");
      _0x830366.textContent = window.cartStrings.error;
    });
  }
}
customElements.define("cart-items", CartItems);
if (!customElements.get("cart-note")) {
  customElements.define("cart-note", class CartNote extends HTMLElement {
    constructor() {
      super();
      this.addEventListener("change", debounce(_0x1d5407 => {
        const _0x2167a6 = JSON.stringify({
          note: _0x1d5407.target.value
        });
        fetch("" + routes.cart_update_url, {
          ...fetchConfig(),
          ...{
            body: _0x2167a6
          }
        });
      }, ON_CHANGE_DEBOUNCE_TIMER));
    }
  });
}
;
function handleDiscountForm(_0x147233) {
  _0x147233.preventDefault();
  const _0xf894a = _0x147233.target.querySelector("[name=cart-discount-field]");
  const _0x34bcbc = _0x147233.target.querySelector(".cart-discount-form__error");
  const _0xb94328 = _0xf894a.value;
  if (_0xb94328 === undefined || _0xb94328.length === 0) {
    _0x34bcbc.style.display = "block";
    return;
  }
  _0x34bcbc.style.display = "none";
  const _0x8f20b7 = "/checkout?discount=";
  const _0x24d3c6 = _0x8f20b7 + _0xb94328;
  window.location.href = _0x24d3c6;
}
function handleDiscountFormChange(_0x1bded1) {
  const _0x24bab6 = document.querySelectorAll(".cart-discount-form__error");
  _0x24bab6.forEach(_0x138a10 => {
    _0x138a10.style.display = "none";
  });
}
class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input[type=\"search\"]");
    this.resetButton = this.querySelector("button[type=\"reset\"]");
    if (this.input) {
      this.input.form.addEventListener("reset", this.onFormReset.bind(this));
      this.input.addEventListener("input", debounce(_0x4fd556 => {
        this.onChange(_0x4fd556);
      }, 300).bind(this));
    }
  }
  toggleResetButton() {
    const _0x1f78c6 = this.resetButton.classList.contains("hidden");
    if (this.input.value.length > 0 && _0x1f78c6) {
      this.resetButton.classList.remove("hidden");
    } else if (this.input.value.length === 0 && !_0x1f78c6) {
      this.resetButton.classList.add("hidden");
    }
  }
  onChange() {
    this.toggleResetButton();
  }
  shouldResetForm() {
    return !document.querySelector("[aria-selected=\"true\"] a");
  }
  onFormReset(_0x4abfe7) {
    _0x4abfe7.preventDefault();
    if (this.shouldResetForm()) {
      this.input.value = "";
      this.input.focus();
      this.toggleResetButton();
    }
  }
}
customElements.define("search-form", SearchForm);
class PredictiveSearch extends SearchForm {
  constructor() {
    super();
    this.cachedResults = {};
    this.predictiveSearchResults = this.querySelector("[data-predictive-search]");
    this.allPredictiveSearchInstances = document.querySelectorAll("predictive-search");
    this.isOpen = false;
    this.abortController = new AbortController();
    this.searchTerm = "";
    this.setupEventListeners();
  }
  setupEventListeners() {
    this.input.form.addEventListener("submit", this.onFormSubmit.bind(this));
    this.input.addEventListener("focus", this.onFocus.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.addEventListener("keyup", this.onKeyup.bind(this));
    this.addEventListener("keydown", this.onKeydown.bind(this));
  }
  getQuery() {
    return this.input.value.trim();
  }
  onChange() {
    super.onChange();
    const _0x31089b = this.getQuery();
    if (!this.searchTerm || !_0x31089b.startsWith(this.searchTerm)) {
      this.querySelector("#predictive-search-results-groups-wrapper")?.remove();
    }
    this.updateSearchForTerm(this.searchTerm, _0x31089b);
    this.searchTerm = _0x31089b;
    if (!this.searchTerm.length) {
      this.close(true);
      return;
    }
    this.getSearchResults(this.searchTerm);
  }
  onFormSubmit(_0x12b55d) {
    if (!this.getQuery().length || this.querySelector("[aria-selected=\"true\"] a")) {
      _0x12b55d.preventDefault();
    }
  }
  onFormReset(_0x3a7cea) {
    super.onFormReset(_0x3a7cea);
    if (super.shouldResetForm()) {
      this.searchTerm = "";
      this.abortController.abort();
      this.abortController = new AbortController();
      this.closeResults(true);
    }
  }
  onFocus() {
    const _0x506ba2 = this.getQuery();
    if (!_0x506ba2.length) {
      return;
    }
    if (this.searchTerm !== _0x506ba2) {
      this.onChange();
    } else if (this.getAttribute("results") === "true") {
      this.open();
    } else {
      this.getSearchResults(this.searchTerm);
    }
  }
  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) {
        this.close();
      }
    });
  }
  onKeyup(_0x5d9d3e) {
    if (!this.getQuery().length) {
      this.close(true);
    }
    _0x5d9d3e.preventDefault();
    switch (_0x5d9d3e.code) {
      case "ArrowUp":
        this.switchOption("up");
        break;
      case "ArrowDown":
        this.switchOption("down");
        break;
      case "Enter":
        this.selectOption();
        break;
    }
  }
  onKeydown(_0x578699) {
    if (_0x578699.code === "ArrowUp" || _0x578699.code === "ArrowDown") {
      _0x578699.preventDefault();
    }
  }
  updateSearchForTerm(_0x299a9e, _0x1b1036) {
    const _0x3d7072 = this.querySelector("[data-predictive-search-search-for-text]");
    const _0x32f310 = _0x3d7072?.innerText;
    if (_0x32f310) {
      if (_0x32f310.match(new RegExp(_0x299a9e, "g")).length > 1) {
        return;
      }
      const _0x5c107c = _0x32f310.replace(_0x299a9e, _0x1b1036);
      _0x3d7072.innerText = _0x5c107c;
    }
  }
  switchOption(_0x19dbc0) {
    if (!this.getAttribute("open")) {
      return;
    }
    const _0x1e9a4b = _0x19dbc0 === "up";
    const _0x515469 = this.querySelector("[aria-selected=\"true\"]");
    const _0x3ef8e8 = Array.from(this.querySelectorAll("li, button.predictive-search__item")).filter(_0x4c2f35 => _0x4c2f35.offsetParent !== null);
    let _0xc85593 = 0;
    if (_0x1e9a4b && !_0x515469) {
      return;
    }
    let _0x1446ab = -1;
    let _0x47b2dd = 0;
    while (_0x1446ab === -1 && _0x47b2dd <= _0x3ef8e8.length) {
      if (_0x3ef8e8[_0x47b2dd] === _0x515469) {
        _0x1446ab = _0x47b2dd;
      }
      _0x47b2dd++;
    }
    this.statusElement.textContent = "";
    if (!_0x1e9a4b && _0x515469) {
      _0xc85593 = _0x1446ab === _0x3ef8e8.length - 1 ? 0 : _0x1446ab + 1;
    } else if (_0x1e9a4b) {
      _0xc85593 = _0x1446ab === 0 ? _0x3ef8e8.length - 1 : _0x1446ab - 1;
    }
    if (_0xc85593 === _0x1446ab) {
      return;
    }
    const _0x51eae4 = _0x3ef8e8[_0xc85593];
    _0x51eae4.setAttribute("aria-selected", true);
    if (_0x515469) {
      _0x515469.setAttribute("aria-selected", false);
    }
    this.input.setAttribute("aria-activedescendant", _0x51eae4.id);
  }
  selectOption() {
    const _0x4b4bb3 = this.querySelector("[aria-selected=\"true\"] a, button[aria-selected=\"true\"]");
    if (_0x4b4bb3) {
      _0x4b4bb3.click();
    }
  }
  getSearchResults(_0x184862) {
    const _0x7b2c10 = _0x184862.replace(" ", "-").toLowerCase();
    this.setLiveRegionLoadingState();
    if (this.cachedResults[_0x7b2c10]) {
      this.renderSearchResults(this.cachedResults[_0x7b2c10]);
      return;
    }
    fetch(routes.predictive_search_url + "?q=" + encodeURIComponent(_0x184862) + "&section_id=predictive-search", {
      signal: this.abortController.signal
    }).then(_0x2704cb => {
      if (!_0x2704cb.ok) {
        var _0x2916fb = new Error(_0x2704cb.status);
        this.close();
        throw _0x2916fb;
      }
      return _0x2704cb.text();
    }).then(_0x4faf27 => {
      const _0x36dc1c = new DOMParser().parseFromString(_0x4faf27, "text/html").querySelector("#shopify-section-predictive-search").innerHTML;
      this.allPredictiveSearchInstances.forEach(_0x3dace9 => {
        _0x3dace9.cachedResults[_0x7b2c10] = _0x36dc1c;
      });
      this.renderSearchResults(_0x36dc1c);
    }).catch(_0x5ea49c => {
      if (_0x5ea49c?.code === 20) {
        return;
      }
      this.close();
      throw _0x5ea49c;
    });
  }
  setLiveRegionLoadingState() {
    this.statusElement = this.statusElement || this.querySelector(".predictive-search-status");
    this.loadingText = this.loadingText || this.getAttribute("data-loading-text");
    this.setLiveRegionText(this.loadingText);
    this.setAttribute("loading", true);
  }
  setLiveRegionText(_0x500886) {
    this.statusElement.setAttribute("aria-hidden", "false");
    this.statusElement.textContent = _0x500886;
    setTimeout(() => {
      this.statusElement.setAttribute("aria-hidden", "true");
    }, 1000);
  }
  renderSearchResults(_0x2008a2) {
    this.predictiveSearchResults.innerHTML = _0x2008a2;
    this.setAttribute("results", true);
    this.setLiveRegionResults();
    this.open();
  }
  setLiveRegionResults() {
    this.removeAttribute("loading");
    this.setLiveRegionText(this.querySelector("[data-predictive-search-live-region-count-value]").textContent);
  }
  getResultsMaxHeight() {
    this.resultsMaxHeight = window.innerHeight - document.querySelector(".section-header").getBoundingClientRect().bottom;
    return this.resultsMaxHeight;
  }
  open() {
    this.predictiveSearchResults.style.maxHeight = this.resultsMaxHeight || this.getResultsMaxHeight() + "px";
    this.setAttribute("open", true);
    this.input.setAttribute("aria-expanded", true);
    this.isOpen = true;
  }
  close(_0x15e026 = false) {
    this.closeResults(_0x15e026);
    this.isOpen = false;
  }
  closeResults(_0x141fc9 = false) {
    if (_0x141fc9) {
      this.input.value = "";
      this.removeAttribute("results");
    }
    const _0x59b995 = this.querySelector("[aria-selected=\"true\"]");
    if (_0x59b995) {
      _0x59b995.setAttribute("aria-selected", false);
    }
    this.input.setAttribute("aria-activedescendant", "");
    this.removeAttribute("loading");
    this.removeAttribute("open");
    this.input.setAttribute("aria-expanded", false);
    this.resultsMaxHeight = false;
    this.predictiveSearchResults.removeAttribute("style");
  }
}
customElements.define("predictive-search", PredictiveSearch);
class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.upsellHandles = this.getUpsellHandles();
    this.checkForClear();
    this.addEventListener("keyup", _0x1dce99 => _0x1dce99.code === "Escape" && this.close());
    this.querySelector("#CartDrawer-Overlay").addEventListener("click", this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }
  setHeaderCartIconAccessibility() {
    const _0x2e26f8 = document.querySelector("#cart-icon-bubble");
    const _0xad4ae8 = _0x2e26f8.closest(".header__icons");
    _0x2e26f8.setAttribute("role", "button");
    _0x2e26f8.setAttribute("aria-haspopup", "dialog");
    _0x2e26f8.addEventListener("click", _0x153176 => {
      _0x153176.preventDefault();
      this.open(_0x2e26f8);
    });
    _0x2e26f8.addEventListener("keydown", _0x3992ee => {
      if (_0x3992ee.code.toUpperCase() === "SPACE") {
        _0x3992ee.preventDefault();
        this.open(_0x2e26f8);
      }
    });
  }
  open(_0x513ad7) {
    if (_0x513ad7) {
      this.setActiveElement(_0x513ad7);
    }
    const _0x1e3160 = this.querySelector("[id^=\"Details-\"] summary");
    if (_0x1e3160 && !_0x1e3160.hasAttribute("role")) {
      this.setSummaryAccessibility(_0x1e3160);
    }
    setTimeout(() => {
      this.classList.add("animate", "active");
    });
    this.addEventListener("transitionend", () => {
      const _0x519a09 = this.classList.contains("is-empty") ? this.querySelector(".drawer__inner-empty") : document.getElementById("CartDrawer");
      const _0x5752e6 = this.querySelector(".drawer__inner") || this.querySelector(".drawer__close");
      trapFocus(_0x519a09, _0x5752e6);
    }, {
      once: true
    });
    document.body.classList.add("overflow-hidden");
    const _0x2e3bd7 = this.querySelector("countdown-timer");
    if (_0x2e3bd7) {
      _0x2e3bd7.playTimer();
    }
  }
  close() {
    this.classList.remove("active");
    removeTrapFocus(this.activeElement);
    document.body.classList.remove("overflow-hidden");
  }
  getUpsellHandles() {
    const _0x53f9b3 = this.querySelectorAll("cart-drawer-upsell[data-toggle=\"true\"], cart-drawer-gift");
    const _0x1f5a33 = [];
    _0x53f9b3.forEach(_0x18629a => {
      if (_0x18629a.dataset.handle) {
        _0x1f5a33.push(_0x18629a.dataset.handle);
      }
    });
    return _0x1f5a33;
  }
  oneNonUpellRemaining() {
    const _0x4f38a4 = this.querySelectorAll(".cart-item");
    let _0x437c9c = 0;
    _0x4f38a4.forEach(_0x4eb7fd => {
      this.upsellHandles.forEach(_0x2e6482 => {
        if (_0x4eb7fd.classList.contains("cart-item--product-" + _0x2e6482)) {
          _0x437c9c++;
        }
      });
    });
    return _0x4f38a4.length - _0x437c9c <= 1;
  }
  checkForClear() {
    const _0x1dc82c = this.oneNonUpellRemaining();
    this.querySelectorAll("cart-remove-button").forEach(_0x316e8f => {
      if (_0x1dc82c) {
        _0x316e8f.clearCart = true;
      } else {
        _0x316e8f.clearCart = false;
      }
    });
  }
  setSummaryAccessibility(_0xe25c0a) {
    _0xe25c0a.setAttribute("role", "button");
    _0xe25c0a.setAttribute("aria-expanded", "false");
    if (_0xe25c0a.nextElementSibling.getAttribute("id")) {
      _0xe25c0a.setAttribute("aria-controls", _0xe25c0a.nextElementSibling.id);
    }
    _0xe25c0a.addEventListener("click", _0x206154 => {
      _0x206154.currentTarget.setAttribute("aria-expanded", !_0x206154.currentTarget.closest("details").hasAttribute("open"));
    });
    _0xe25c0a.parentElement.addEventListener("keyup", onKeyUpEscape);
  }
  renderContents(_0x315e84, _0x33e9df = false) {
    if (this.querySelector(".drawer__inner").classList.contains("is-empty")) {
      this.querySelector(".drawer__inner").classList.remove("is-empty");
    }
    this.productId = _0x315e84.id;
    this.getSectionsToRender().forEach(_0x4527ab => {
      const _0x390755 = _0x4527ab.selector ? document.querySelector(_0x4527ab.selector) : document.getElementById(_0x4527ab.id);
      if (_0x390755) {
        _0x390755.innerHTML = this.getSectionInnerHTML(_0x315e84.sections[_0x4527ab.id], _0x4527ab.selector);
      }
    });
    this.checkForClear();
    const _0x31d4dd = this.querySelector("countdown-timer");
    if (_0x31d4dd && _0x31d4dd.playTimer) {
      _0x31d4dd.playTimer();
    }
    let _0x2bae07 = [];
    let _0x47eb76 = [];
    this.querySelectorAll("cart-drawer-gift").forEach(_0x16fe0c => {
      if (_0x16fe0c.getUpdateRequired()) {
        if (this.querySelector(".cart-item--product-" + _0x16fe0c.dataset.handle)) {
          if (_0x16fe0c.dataset.selected === "false") {
            _0x47eb76.push(_0x16fe0c);
          }
        } else if (_0x16fe0c.dataset.selected === "true") {
          _0x2bae07.push(_0x16fe0c);
        }
      }
    });
    if (_0x47eb76.length > 0) {
      _0x47eb76[0].removeFromCart();
    } else if (_0x2bae07.length > 0) {
      _0x2bae07[0].addToCart();
    }
    setTimeout(() => {
      this.querySelector("#CartDrawer-Overlay").addEventListener("click", this.close.bind(this));
      if (_0x33e9df) {
        return;
      }
      this.open();
    });
  }
  getSectionInnerHTML(_0x501dc5, _0x273db9 = ".shopify-section") {
    let _0x45c79a = new DOMParser().parseFromString(_0x501dc5, "text/html").querySelector(_0x273db9);
    if (_0x273db9 === "#CartDrawer") {
      fixParsedHtml(this, _0x45c79a);
    }
    let _0xb7d629 = _0x45c79a.innerHTML;
    return _0xb7d629;
  }
  getSectionsToRender() {
    return [{
      id: "cart-drawer",
      selector: "#CartDrawer"
    }, {
      id: "cart-icon-bubble"
    }];
  }
  getSectionDOM(_0x49181c, _0x5234d6 = ".shopify-section") {
    return new DOMParser().parseFromString(_0x49181c, "text/html").querySelector(_0x5234d6);
  }
  setActiveElement(_0x499cec) {
    this.activeElement = _0x499cec;
  }
}
customElements.define("cart-drawer", CartDrawer);
class CartDrawerItems extends CartItems {
  constructor() {
    super();
    this.cartDrawer = document.querySelector("cart-drawer");
    this.secondCartItems = document.querySelector("cart-items");
  }
  updateCart() {
    fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        updates: {},
        sections: ["cart-drawer", "cart-icon-bubble"],
        sections_url: window.location.pathname
      })
    }).then(_0x338c03 => _0x338c03.json()).then(_0x27589e => {
      document.querySelector("cart-drawer").renderContents(_0x27589e, true);
    }).catch(_0x2f5368 => {
      console.error(_0x2f5368);
    });
  }
  getSectionInnerHTML(_0x4f588e, _0x48c713) {
    let _0x73bbea = new DOMParser().parseFromString(_0x4f588e, "text/html").querySelector(_0x48c713);
    if (_0x48c713 === ".drawer__inner") {
      fixParsedHtml(this.cartDrawer, _0x73bbea);
    }
    let _0x5202ac = _0x73bbea.innerHTML;
    return _0x5202ac;
  }
  getSectionsToRender() {
    return [{
      id: "CartDrawer",
      section: "cart-drawer",
      selector: ".drawer__inner"
    }, {
      id: "cart-icon-bubble",
      section: "cart-icon-bubble",
      selector: ".shopify-section"
    }];
  }
}
customElements.define("cart-drawer-items", CartDrawerItems);
function fixParsedHtml(_0x59c9f5, _0x3d094a) {
  const _0x141755 = _0x3d094a.querySelector(".cart-timer");
  if (_0x141755) {
    oldTimer = _0x59c9f5.querySelector(".cart-timer");
    if (oldTimer) {
      _0x141755.innerHTML = oldTimer.innerHTML;
    }
  }
  const _0x5cf940 = _0x59c9f5.querySelectorAll("cart-drawer-upsell[data-toggle=\"true\"], cart-drawer-gift");
  let _0x4f4910 = _0x3d094a.querySelectorAll("cart-drawer-upsell[data-toggle=\"true\"], cart-drawer-gift");
  _0x5cf940.forEach((_0x273be7, _0x834dbb) => {
    if (_0x273be7.nodeName.toLowerCase() === "cart-drawer-upsell") {
      _0x4f4910[_0x834dbb].dataset.selected = _0x273be7.dataset.selected;
    }
    _0x4f4910[_0x834dbb].dataset.id = _0x273be7.dataset.id;
    _0x4f4910[_0x834dbb].querySelector("[name=\"id\"]").value = _0x273be7.querySelector("[name=\"id\"]").value;
    if (_0x4f4910[_0x834dbb].querySelector(".upsell__image__img")) {
      _0x4f4910[_0x834dbb].querySelector(".upsell__image__img").src = _0x273be7.querySelector(".upsell__image__img").src;
    }
    if (_0x4f4910[_0x834dbb].querySelector(".upsell__variant-picker")) {
      const _0x10eea5 = _0x273be7.querySelectorAll(".select__select");
      _0x4f4910[_0x834dbb].querySelectorAll(".select__select").forEach((_0x484345, _0x2472b5) => {
        _0x484345.value = _0x10eea5[_0x2472b5].value;
        _0x484345.querySelectorAll("option").forEach(_0x9d8b52 => {
          _0x9d8b52.removeAttribute("selected");
          if (_0x9d8b52.value === _0x10eea5[_0x2472b5].value.trim()) {
            _0x9d8b52.setAttribute("selected", "");
          }
        });
      });
    }
    if (_0x273be7.dataset.updatePrices === "true") {
      var _0x23af72 = _0x4f4910[_0x834dbb].querySelector(".upsell__price");
      var _0x11ffbb = _0x273be7.querySelector(".upsell__price");
      if (_0x23af72 && _0x11ffbb) {
        _0x23af72.innerHTML = _0x11ffbb.innerHTML;
      }
    }
  });
}
if (!customElements.get("product-form")) {
  customElements.define("product-form", class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector("form");
      this.form.addEventListener("submit", this.handleSubmit.bind(this));
      this.formIdInput = this.form.querySelector("[name=id]");
      this.formIdInput.disabled = false;
      this.isMain = this.classList.contains("main-product-form");
      this.additionalAtcButtons = this.isMain ? document.querySelectorAll(".main-product-atc") : [];
      this.skipCart = this.formIdInput.dataset.skipCart === "true";
      this.cart = document.querySelector("cart-drawer") || document.querySelector("cart-notification");
      this.isCartUpsell = this.dataset.isCartUpsell === "true";
      this.submitButton = this.querySelector("[type=\"submit\"]");
      if (document.querySelector("cart-drawer")) {
        this.submitButton.setAttribute("aria-haspopup", "dialog");
        this.hasDrawer = true;
      }
      this.loadingSpinner = this.submitButton.querySelector(".loading-overlay__spinner");
      this.displayedSubmitButton = document.getElementById("DisplayedSubmitBtn-" + this.dataset.section);
      this.bundleDeals = document.getElementById("bundle-deals-" + this.dataset.section);
      this.productInfo = document.getElementById("ProductInfo-" + this.dataset.section);
      this.quantityBreaks = document.getElementById("quantity-breaks-" + this.dataset.section);
      this.quantityPicker = document.getElementById("Quantity-Form-" + this.dataset.section);
      this.customFields = document.querySelectorAll("[id^='CustomField-" + this.dataset.section + "-']");
      this.quantityGifts = document.getElementById("quantity-gifts-" + this.dataset.section);
      this.mainBundleItems = document.querySelectorAll(".main-offer-item-" + this.dataset.section);
      this.variantInputs = this.form.querySelector(".product-form__variants");
    }
    handleSubmit(_0x290a3d) {
      let _0x1006b1 = null;
      let _0x5b5e8b = false;
      if (_0x290a3d) {
        _0x290a3d.preventDefault();
        if (_0x290a3d.currentTarget.classList.contains("button--has-spinner")) {
          _0x1006b1 = _0x290a3d.currentTarget;
          _0x1006b1.classList.add("loading");
        }
        if (_0x290a3d.currentTarget.dataset.skipCartButton === "true") {
          _0x5b5e8b = true;
        }
      }
      if (this.submitButton.getAttribute("aria-disabled") === "true") {
        return;
      }
      this.handleErrorMessage();
      this.submitButton.setAttribute("aria-disabled", true);
      if (!_0x1006b1) {
        this.submitButton.classList.add("loading");
        if (this.loadingSpinner) {
          this.loadingSpinner.classList.remove("hidden");
        }
      }
      this.additionalAtcButtons.forEach(_0x56c0a6 => {
        _0x56c0a6.setAttribute("disabled", "");
      });
      if (this.displayedSubmitButton) {
        this.displayedSubmitButton.setAttribute("disabled", "");
        this.displayedSubmitButton.classList.add("loading");
      }
      let _0x2a769c = false;
      if (this.variantInputs) {
        this.variantInputs.innerHTML = "";
        let _0x336e46 = "";
        let _0x5ecaa3 = [];
        if (this.hasDrawer && !this.isCartUpsell && !this.skipCart) {
          this.cart.querySelectorAll("cart-drawer-upsell[data-toggle=\"true\"], cart-drawer-gift").forEach(_0x2037df => {
            if (_0x2037df.dataset.selected === "true" && !this.cart.querySelector(".cart-item--product-" + _0x2037df.dataset.handle)) {
              _0x5ecaa3.unshift(_0x2037df.dataset.id);
            }
          });
        }
        if (this.bundleDeals) {
          _0x2a769c = true;
          if (this.dataset.includePdpUpsells === "true") {
            document.querySelectorAll("product-info-upsell").forEach(_0x361e3d => {
              if (_0x361e3d.dataset.selected === "true") {
                _0x5ecaa3.unshift(_0x361e3d.dataset.id);
              }
            });
          }
          for (let _0x1001e9 = 0; _0x1001e9 < _0x5ecaa3.length; _0x1001e9++) {
            _0x336e46 += "<input type=\"hidden\" name=\"items[" + _0x1001e9 + "][quantity]\" value=\"1\"><input type=\"hidden\" name=\"items[" + _0x1001e9 + "][id]\" value=\"" + _0x5ecaa3[_0x1001e9] + "\">";
          }
          let _0xeab5e1 = _0x5ecaa3.length;
          for (let _0x25bee2 = 0; _0x25bee2 < this.bundleDeals.formVariants.length; _0x25bee2++) {
            const _0x288781 = this.bundleDeals.formVariants[_0x25bee2];
            _0x336e46 += "<input type=\"hidden\" name=\"items[" + (_0x25bee2 + _0xeab5e1) + "][quantity]\" value=\"" + _0x288781.quantity + "\"><input type=\"hidden\" name=\"items[" + (_0x25bee2 + _0xeab5e1) + "][id]\" value=\"" + _0x288781.id + "\">";
          }
          this.variantInputs.innerHTML = _0x336e46;
        } else {
          let _0x4a13aa = [];
          if (this.quantityGifts && this.quantityGifts.unlockedItems.length > 0) {
            _0x5ecaa3 = [..._0x5ecaa3, ...this.quantityGifts.unlockedItems];
          }
          this.upsells = document.querySelectorAll(".product-info-upsell-" + this.dataset.section);
          for (let _0x3b52ca = this.upsells.length - 1; _0x3b52ca >= 0; _0x3b52ca--) {
            if (this.upsells[_0x3b52ca].dataset.selected === "true") {
              _0x5ecaa3.push(this.upsells[_0x3b52ca].dataset.id);
            }
          }
          if (this.mainBundleItems.length === 0) {
            if (this.quantityBreaks && this.quantityBreaks.formVariants.length > 0) {
              _0x5ecaa3 = [..._0x5ecaa3, ...this.quantityBreaks.formVariants];
              _0x4a13aa = [...this.quantityBreaks.formVariants];
            } else if (_0x5ecaa3.length > 0 && (!this.quantityBreaks || this.quantityBreaks.formVariants.length === 0)) {
              let _0x17433c = 1;
              if (this.quantityBreaks) {
                _0x17433c = this.quantityBreaks.selectedQuantity;
              } else if (this.quantityPicker) {
                _0x17433c = parseInt(this.quantityPicker.querySelector(".quantity__input").value);
              }
              for (let _0x27856f = 0; _0x27856f < _0x17433c; _0x27856f++) {
                _0x5ecaa3.push(this.formIdInput.value);
              }
              _0x4a13aa = [this.formIdInput.value];
            }
          }
          for (let _0x5aac03 = this.mainBundleItems.length - 1; _0x5aac03 >= 0; _0x5aac03--) {
            _0x5ecaa3.push(this.mainBundleItems[_0x5aac03].dataset.id);
            _0x4a13aa.push(this.mainBundleItems[_0x5aac03].dataset.id);
          }
          if (_0x5ecaa3.length > 0) {
            _0x2a769c = true;
            const _0x3d2081 = [];
            for (let _0x5d8adf = 0; _0x5d8adf < _0x5ecaa3.length; _0x5d8adf++) {
              const _0x491491 = _0x5ecaa3[_0x5d8adf];
              const _0xc2953d = _0x3d2081.findIndex(_0x344fd0 => _0x344fd0.id === _0x491491);
              if (_0xc2953d < 0) {
                _0x3d2081.push({
                  id: _0x491491,
                  quantity: 1
                });
              } else {
                _0x3d2081[_0xc2953d].quantity += 1;
              }
            }
            let _0x53b08b = [];
            this.customFields.forEach(_0x166bbb => {
              if (_0x166bbb.dataset.disabled != "true") {
                _0x53b08b.push({
                  fieldName: _0x166bbb.fieldName,
                  value: _0x166bbb.prevValue
                });
              }
            });
            if (this.classList.contains("main-product-form")) {
              this.sellingPlanInput = this.querySelector(".appstle-active-option [name=\"selling_plan\"]") || this.querySelector("[name=\"selling_plan\"]") || document.querySelector(".sls-purchase [name=\"selling_plan\"]");
              this.simpleBundlesContainer = this.querySelector("#simple-bundles-io-options");
              this.appPropertyInputs = document.querySelectorAll(".cl-upload--wrapper input[name^=\"properties[\"], .uploadkit-attribute-container input[name^=\"properties[\"], .gpo-hidden-inputs input:not(#validator)");
            }
            for (let _0x5b4970 = 0; _0x5b4970 < _0x3d2081.length; _0x5b4970++) {
              const _0x57b9f4 = _0x3d2081[_0x5b4970];
              _0x336e46 += "<input type=\"hidden\" name=\"items[" + _0x5b4970 + "][quantity]\" value=\"" + _0x57b9f4.quantity + "\"><input type=\"hidden\" name=\"items[" + _0x5b4970 + "][id]\" value=\"" + _0x57b9f4.id + "\">";
              if (_0x4a13aa.includes(_0x57b9f4.id)) {
                _0x53b08b.forEach(_0xe2c037 => {
                  _0x336e46 += "<input type=\"hidden\" name=\"items[" + _0x5b4970 + "][properties][" + _0xe2c037.fieldName + "]\" value=\"" + _0xe2c037.value + "\">";
                });
                if (this.sellingPlanInput && typeof this.sellingPlanInput.value === "string" && this.sellingPlanInput.value.length > 0) {
                  _0x336e46 += "<input type=\"hidden\" name=\"items[" + _0x5b4970 + "][selling_plan]\" value=\"" + this.sellingPlanInput.value + "\">";
                }
                if (this.simpleBundlesContainer) {
                  this.simpleBundlesContainer.querySelectorAll("select").forEach(_0x2ac759 => {
                    const _0x277c7e = _0x2ac759.name.match(/properties\[(.*?)\]/);
                    if (_0x277c7e) {
                      let _0x2e89ea = _0x277c7e[1];
                      _0x336e46 += "<input type=\"hidden\" name=\"items[" + _0x5b4970 + "][properties][" + _0x2e89ea + "]\" value=\"" + _0x2ac759.value + "\">";
                    }
                  });
                }
                if (this.classList.contains("main-product-form")) {
                  this.appPropertyInputs.forEach(_0x179cb8 => {
                    let _0x30a868 = _0x179cb8.name.match(/properties\[(.*?)\]/)[1];
                    _0x336e46 += "<input type=\"hidden\" name=\"items[" + _0x5b4970 + "][properties][" + _0x30a868 + "]\" value=\"" + _0x179cb8.value + "\">";
                  });
                }
              }
            }
            this.variantInputs.innerHTML = _0x336e46;
          }
        }
      }
      var _0x136ee1 = fetchConfig("javascript");
      _0x136ee1.headers["X-Requested-With"] = "XMLHttpRequest";
      delete _0x136ee1.headers["Content-Type"];
      var _0xada03e = new FormData(this.form);
      if (this.cart) {
        _0xada03e.append("sections", this.cart.getSectionsToRender().map(_0xa94ea8 => _0xa94ea8.id));
        _0xada03e.append("sections_url", window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      if (_0x2a769c && document.querySelector("quantity-breaks")) {
        const _0x3a6e6e = this.dataset.options ? this.dataset.options.split(",") : [];
        const _0x56891f = ["id", "quantity", ..._0x3a6e6e];
        for (let _0x45310a = 0; _0x45310a < _0x56891f.length; _0x45310a++) {
          _0xada03e.delete(_0x56891f[_0x45310a]);
        }
      }
      _0x136ee1.body = _0xada03e;
      fetch("/cart/add", _0x136ee1).then(_0x5e18a1 => _0x5e18a1.json()).then(_0x1c973a => {
        if (_0x1c973a.status) {
          this.handleErrorMessage(_0x1c973a.description);
          const _0x24691e = this.submitButton.querySelector(".sold-out-message");
          if (!_0x24691e) {
            return;
          }
          this.submitButton.setAttribute("aria-disabled", true);
          this.submitButton.querySelector("span").classList.add("hidden");
          _0x24691e.classList.remove("hidden");
          this.error = true;
          return;
        } else if (this.skipCart || _0x5b5e8b) {
          window.location = "/checkout";
          return;
        } else if (!this.cart) {
          window.location = window.routes.cart_url;
          return;
        }
        if (!this.error) {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: "product-form"
          });
        }
        this.error = false;
        const _0x55d369 = this.closest("quick-add-modal");
        if (_0x55d369) {
          document.body.addEventListener("modalClosed", () => {
            setTimeout(() => {
              this.cart.renderContents(_0x1c973a, this.isCartUpsell);
            });
          }, {
            once: true
          });
          _0x55d369.hide(true);
        } else {
          this.cart.open();
        }
        this.cart.renderContents(_0x1c973a, this.isCartUpsell);
      }).catch(_0x1814e8 => {
        console.error(_0x1814e8);
      }).finally(() => {
        if (_0x1006b1) {
          _0x1006b1.classList.remove("loading");
        } else {
          this.submitButton.classList.remove("loading");
          if (this.loadingSpinner) {
            this.loadingSpinner.classList.add("hidden");
          }
        }
        this.additionalAtcButtons.forEach(_0x47922b => {
          _0x47922b.removeAttribute("disabled");
        });
        if (this.displayedSubmitButton) {
          this.displayedSubmitButton.removeAttribute("disabled");
          this.displayedSubmitButton.classList.remove("loading");
        }
        if (this.cart && this.cart.classList.contains("is-empty")) {
          this.cart.classList.remove("is-empty");
        }
        if (!this.error) {
          this.submitButton.removeAttribute("aria-disabled");
        }
      });
    }
    handleErrorMessage(_0x3ba1cc = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector(".product-form__error-message-wrapper");
      if (!this.errorMessageWrapper) {
        return;
      }
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector(".product-form__error-message");
      this.errorMessageWrapper.toggleAttribute("hidden", !_0x3ba1cc);
      if (_0x3ba1cc) {
        this.errorMessage.textContent = _0x3ba1cc;
      }
    }
  });
}
if (!customElements.get("product-info")) {
  customElements.define("product-info", class ProductInfo extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector(".quantity__input");
      this.currentVariant = this.querySelector(".product-variant-id");
      this.variantSelects = this.querySelector("variant-radios");
      this.submitButton = this.querySelector("[type=\"submit\"]");
      this.form = this.querySelector("#ProductForm-" + this.dataset.section);
      this.hasUrl = this.dataset.url !== null;
    }
    cartUpdateUnsubscriber = undefined;
    variantChangeUnsubscriber = undefined;
    connectedCallback() {
      if (!this.input) {
        return;
      }
      this.quantityForm = this.querySelector(".product-form__quantity");
      if (!this.quantityForm) {
        return;
      }
      this.setQuantityBoundries();
      if (!this.dataset.originalSection) {
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
      }
      this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, _0x45cab8 => {
        const _0x1e98d0 = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
        if (_0x45cab8.data.sectionId !== _0x1e98d0) {
          return;
        }
        this.updateQuantityRules(_0x45cab8.data.sectionId, _0x45cab8.data.html);
        this.setQuantityBoundries();
      });
      if (!this.form) {
        return;
      }
    }
    disconnectedCallback() {
      if (this.cartUpdateUnsubscriber) {
        this.cartUpdateUnsubscriber();
      }
      if (this.variantChangeUnsubscriber) {
        this.variantChangeUnsubscriber();
      }
    }
    setQuantityBoundries() {
      const _0x2912d3 = {
        cartQuantity: this.input.dataset.cartQuantity ? parseInt(this.input.dataset.cartQuantity) : 0,
        min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
        max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
        step: this.input.step ? parseInt(this.input.step) : 1
      };
      let _0x2bdf65 = _0x2912d3.min;
      const _0x4ae596 = _0x2912d3.max === null ? _0x2912d3.max : _0x2912d3.max - _0x2912d3.cartQuantity;
      if (_0x4ae596 !== null) {
        _0x2bdf65 = Math.min(_0x2bdf65, _0x4ae596);
      }
      if (_0x2912d3.cartQuantity >= _0x2912d3.min) {
        _0x2bdf65 = Math.min(_0x2bdf65, _0x2912d3.step);
      }
      this.input.min = _0x2bdf65;
      this.input.max = _0x4ae596;
      this.input.value = _0x2bdf65;
      publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
    }
    initShareLinks() {
      const _0x554361 = this.querySelector(".share-url-button");
      if (!_0x554361) {
        this.shareUrl = true;
      }
    }
    fetchQuantityRules() {
      if (!this.currentVariant || !this.currentVariant.value) {
        return;
      }
      this.querySelector(".quantity__rules-cart .loading-overlay").classList.remove("hidden");
      fetch(this.dataset.url + "?variant=" + this.currentVariant.value + "&section_id=" + this.dataset.section).then(_0x15a623 => {
        return _0x15a623.text();
      }).then(_0x1fd315 => {
        const _0x33b25b = new DOMParser().parseFromString(_0x1fd315, "text/html");
        this.updateQuantityRules(this.dataset.section, _0x33b25b);
        this.setQuantityBoundries();
      }).catch(_0x3235bf => {
        console.error(_0x3235bf);
      }).finally(() => {
        this.querySelector(".quantity__rules-cart .loading-overlay").classList.add("hidden");
      });
    }
    updateQuantityRules(_0x89c27, _0x27b16a) {
      const _0x301355 = _0x27b16a.getElementById("Quantity-Form-" + _0x89c27);
      const _0x48e714 = [".quantity__input", ".quantity__rules", ".quantity__label"];
      for (let _0x184cc7 of _0x48e714) {
        const _0x26ed4e = this.quantityForm.querySelector(_0x184cc7);
        const _0x17adf4 = _0x301355.querySelector(_0x184cc7);
        if (!_0x26ed4e || !_0x17adf4) {
          continue;
        }
        if (_0x184cc7 === ".quantity__input") {
          const _0x4cc16c = ["data-cart-quantity", "data-min", "data-max", "step"];
          for (let _0x1fb087 of _0x4cc16c) {
            const _0x3e363b = _0x17adf4.getAttribute(_0x1fb087);
            if (_0x3e363b !== null) {
              _0x26ed4e.setAttribute(_0x1fb087, _0x3e363b);
            }
          }
        } else {
          _0x26ed4e.innerHTML = _0x17adf4.innerHTML;
        }
      }
    }
  });
}
;
function getFocusableElements(_0x3fed8e) {
  return Array.from(_0x3fed8e.querySelectorAll("summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"));
}
document.querySelectorAll("[id^=\"Details-\"] summary").forEach(_0x12f7c3 => {
  _0x12f7c3.setAttribute("role", "button");
  _0x12f7c3.setAttribute("aria-expanded", _0x12f7c3.parentNode.hasAttribute("open"));
  if (_0x12f7c3.nextElementSibling.getAttribute("id")) {
    _0x12f7c3.setAttribute("aria-controls", _0x12f7c3.nextElementSibling.id);
  }
  _0x12f7c3.addEventListener("click", _0x561332 => {
    _0x561332.currentTarget.setAttribute("aria-expanded", !_0x561332.currentTarget.closest("details").hasAttribute("open"));
  });
  if (_0x12f7c3.closest("header-drawer")) {
    return;
  }
  _0x12f7c3.parentElement.addEventListener("keyup", onKeyUpEscape);
});
const trapFocusHandlers = {};
function trapFocus(_0x48d0b0, _0x4bf7be = _0x48d0b0) {
  var _0x49e26c = getFocusableElements(_0x48d0b0);
  var _0x27c9c7 = _0x49e26c[0];
  var _0x20cb68 = _0x49e26c[_0x49e26c.length - 1];
  removeTrapFocus();
  trapFocusHandlers.focusin = _0x1fdba1 => {
    if (_0x1fdba1.target !== _0x48d0b0 && _0x1fdba1.target !== _0x20cb68 && _0x1fdba1.target !== _0x27c9c7) {
      return;
    }
    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };
  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };
  trapFocusHandlers.keydown = function (_0x34abf9) {
    if (_0x34abf9.code.toUpperCase() !== "TAB") {
      return;
    }
    if (_0x34abf9.target === _0x20cb68 && !_0x34abf9.shiftKey) {
      _0x34abf9.preventDefault();
      _0x27c9c7.focus();
    }
    if ((_0x34abf9.target === _0x48d0b0 || _0x34abf9.target === _0x27c9c7) && _0x34abf9.shiftKey) {
      _0x34abf9.preventDefault();
      _0x20cb68.focus();
    }
  };
  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);
  _0x4bf7be.focus();
  if (_0x4bf7be.tagName === "INPUT" && ["search", "text", "email", "url"].includes(_0x4bf7be.type) && _0x4bf7be.value) {
    _0x4bf7be.setSelectionRange(0, _0x4bf7be.value.length);
  }
}
function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach(_0x4d48f4 => {
    _0x4d48f4.contentWindow.postMessage("{\"event\":\"command\",\"func\":\"pauseVideo\",\"args\":\"\"}", "*");
  });
  document.querySelectorAll(".js-vimeo").forEach(_0x4dd8e8 => {
    _0x4dd8e8.contentWindow.postMessage("{\"method\":\"pause\"}", "*");
  });
  document.querySelectorAll("media-gallery template video").forEach(_0x24109c => _0x24109c.pause());
  document.querySelectorAll("product-model").forEach(_0x182509 => {
    if (_0x182509.modelViewerUI) {
      _0x182509.modelViewerUI.pause();
    }
  });
}
function removeTrapFocus(_0x639c47 = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);
  if (_0x639c47) {
    _0x639c47.focus();
  }
}
function onKeyUpEscape(_0x4aee82) {
  if (_0x4aee82.code.toUpperCase() !== "ESCAPE") {
    return;
  }
  const _0x384cc1 = _0x4aee82.target.closest("details[open]");
  if (!_0x384cc1) {
    return;
  }
  const _0x15cea8 = _0x384cc1.querySelector("summary");
  _0x384cc1.removeAttribute("open");
  _0x15cea8.setAttribute("aria-expanded", false);
  _0x15cea8.focus();
}
class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", {
      bubbles: true
    });
    this.quantityGifts = document.getElementById("quantity-gifts-" + this.dataset.section);
    this.input.addEventListener("change", this.onInputChange.bind(this));
    this.querySelectorAll("button").forEach(_0x59e9a2 => _0x59e9a2.addEventListener("click", this.onButtonClick.bind(this)));
  }
  quantityUpdateUnsubscriber = undefined;
  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }
  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }
  onInputChange(_0xccf941) {
    this.validateQtyRules();
  }
  onButtonClick(_0x5c43ac) {
    _0x5c43ac.preventDefault();
    const _0x26b236 = this.input.value;
    if (_0x5c43ac.target.name === "plus") {
      this.input.stepUp();
    } else {
      this.input.stepDown();
    }
    if (_0x26b236 !== this.input.value) {
      this.input.dispatchEvent(this.changeEvent);
    }
  }
  validateQtyRules() {
    const _0x3e1187 = parseInt(this.input.value);
    if (this.input.min) {
      const _0x560314 = parseInt(this.input.min);
      const _0x1b3aef = this.querySelector(".quantity__button[name='minus']");
      _0x1b3aef.classList.toggle("disabled", _0x3e1187 <= _0x560314);
    }
    if (this.input.max) {
      const _0x44edaf = parseInt(this.input.max);
      const _0x205620 = this.querySelector(".quantity__button[name='plus']");
      _0x205620.classList.toggle("disabled", _0x3e1187 >= _0x44edaf);
    }
    if (this.quantityGifts && this.quantityGifts.unlockGifts) {
      this.quantityGifts.unlockGifts(_0x3e1187);
    }
  }
}
customElements.define("quantity-input", QuantityInput);
function debounce(_0x5d8b96, _0x2bcdae) {
  let _0x4d59eb;
  return (..._0x59c48a) => {
    clearTimeout(_0x4d59eb);
    _0x4d59eb = setTimeout(() => _0x5d8b96.apply(this, _0x59c48a), _0x2bcdae);
  };
}
function fetchConfig(_0x4862ea = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/" + _0x4862ea
    }
  };
}
function addDays(_0x3f8624, _0x166bd3) {
  var _0x2a7e11 = new Date(_0x3f8624);
  _0x2a7e11.setDate(_0x2a7e11.getDate() + _0x166bd3);
  return _0x2a7e11;
}
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}
Shopify.bind = function (_0x385cc5, _0x3c248e) {
  return function () {
    return _0x385cc5.apply(_0x3c248e, arguments);
  };
};
Shopify.setSelectorByValue = function (_0x34d992, _0x43f82f) {
  for (var _0x183745 = 0, _0x5bc4e7 = _0x34d992.options.length; _0x183745 < _0x5bc4e7; _0x183745++) {
    var _0x3b0252 = _0x34d992.options[_0x183745];
    if (_0x43f82f == _0x3b0252.value || _0x43f82f == _0x3b0252.innerHTML) {
      _0x34d992.selectedIndex = _0x183745;
      return _0x183745;
    }
  }
};
Shopify.addListener = function (_0x582fd6, _0x19bc62, _0x4d3d6c) {
  if (_0x582fd6.addEventListener) {
    _0x582fd6.addEventListener(_0x19bc62, _0x4d3d6c, false);
  } else {
    _0x582fd6.attachEvent("on" + _0x19bc62, _0x4d3d6c);
  }
};
Shopify.postLink = function (_0x54184e, _0x2e4c25) {
  _0x2e4c25 = _0x2e4c25 || {};
  var _0x4c86d5 = _0x2e4c25.method || "post";
  var _0x2e6889 = _0x2e4c25.parameters || {};
  var _0x5ab5f0 = document.createElement("form");
  _0x5ab5f0.setAttribute("method", _0x4c86d5);
  _0x5ab5f0.setAttribute("action", _0x54184e);
  for (var _0xe8510 in _0x2e6889) {
    var _0x226157 = document.createElement("input");
    _0x226157.setAttribute("type", "hidden");
    _0x226157.setAttribute("name", _0xe8510);
    _0x226157.setAttribute("value", _0x2e6889[_0xe8510]);
    _0x5ab5f0.appendChild(_0x226157);
  }
  document.body.appendChild(_0x5ab5f0);
  _0x5ab5f0.submit();
  document.body.removeChild(_0x5ab5f0);
};
Shopify.CountryProvinceSelector = function (_0x262392, _0x3b01e5, _0x3f2b6d) {
  this.countryEl = document.getElementById(_0x262392);
  this.provinceEl = document.getElementById(_0x3b01e5);
  this.provinceContainer = document.getElementById(_0x3f2b6d.hideElement || _0x3b01e5);
  Shopify.addListener(this.countryEl, "change", Shopify.bind(this.countryHandler, this));
  this.initCountry();
  this.initProvince();
};
Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var _0x3a9514 = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, _0x3a9514);
    this.countryHandler();
  },
  initProvince: function () {
    var _0x200aeb = this.provinceEl.getAttribute("data-default");
    if (_0x200aeb && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, _0x200aeb);
    }
  },
  countryHandler: function (_0x3cddec) {
    var _0x367422 = this.countryEl.options[this.countryEl.selectedIndex];
    var _0x49360a = _0x367422.getAttribute("data-provinces");
    var _0x34d722 = JSON.parse(_0x49360a);
    this.clearOptions(this.provinceEl);
    if (_0x34d722 && _0x34d722.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var _0x1298bf = 0; _0x1298bf < _0x34d722.length; _0x1298bf++) {
        var _0x367422 = document.createElement("option");
        _0x367422.value = _0x34d722[_0x1298bf][0];
        _0x367422.innerHTML = _0x34d722[_0x1298bf][1];
        this.provinceEl.appendChild(_0x367422);
      }
      this.provinceContainer.style.display = "";
    }
  },
  clearOptions: function (_0x548ed9) {
    while (_0x548ed9.firstChild) {
      _0x548ed9.removeChild(_0x548ed9.firstChild);
    }
  },
  setOptions: function (_0x546303, _0x57c6b8) {
    for (var _0x55054d = 0, _0x29d1d8 = _0x57c6b8.length; _0x55054d < _0x57c6b8.length; _0x55054d++) {
      var _0x47d8d3 = document.createElement("option");
      _0x47d8d3.value = _0x57c6b8[_0x55054d];
      _0x47d8d3.innerHTML = _0x57c6b8[_0x55054d];
      _0x546303.appendChild(_0x47d8d3);
    }
  }
};
class InternalVideo extends HTMLElement {
  constructor() {
    super();
    this.playButton = this.querySelector(".internal-video__play");
    this.noPlayBtn = this.dataset.noPlayBtn === "true";
    this.loaded = false;
    this.suspended = false;
    this.soundButton = this.querySelector(".internal-video__sound-btn");
    this.video = this.querySelector("video");
    this.invalidFormatSrc = this.video.querySelector("source[type=\"application/x-mpegURL\"]");
    if (this.invalidFormatSrc) {
      this.invalidFormatSrc.remove();
    }
    this.timeline = this.querySelector(".internal-video__timeline");
    this.dragging = false;
    if (this.playButton) {
      this.playButton.addEventListener("click", this.playVideo.bind(this));
    }
    if (this.soundButton) {
      this.soundButton.addEventListener("click", this.toggleSound.bind(this));
    }
    if (this.video) {
      this.video.addEventListener("ended", this.endedVideo.bind(this));
    }
    if (this.timeline) {
      this.video.addEventListener("timeupdate", this.updateTimeline.bind(this));
      this.timeline.addEventListener("click", this.seekVideo.bind(this));
      this.timeline.addEventListener("mousedown", this.startDrag.bind(this));
      this.timeline.addEventListener("touchstart", this.startDrag.bind(this));
      document.addEventListener("mouseup", this.stopDrag.bind(this));
      document.addEventListener("touchend", this.stopDrag.bind(this));
      document.addEventListener("mousemove", this.drag.bind(this));
      document.addEventListener("touchmove", this.drag.bind(this));
    }
    this.video.addEventListener("waiting", this.showSpinner.bind(this));
    this.video.addEventListener("canplaythrough", this.hideSpinner.bind(this));
    this.video.addEventListener("play", this.hideSpinner.bind(this));
    if (this.dataset.autoplay === "true" && "IntersectionObserver" in window) {
      const _0x156a1a = {
        root: null,
        rootMargin: "0px",
        threshold: 0.05
      };
      this.observer = new IntersectionObserver(this.handleIntersection.bind(this), _0x156a1a);
      this.observer.observe(this);
    }
  }
  playVideo() {
    if (this.video.paused) {
      if (!this.loaded) {
        this.video.load();
        this.loaded = true;
      }
      this.classList.add("internal-video--playing");
      if (this.playButton && this.noPlayBtn) {
        this.playButton.style.visibility = "hidden";
      }
      const _0x1e4ed6 = this.video.play();
      if (_0x1e4ed6 !== undefined) {
        _0x1e4ed6.then(() => {
          this.classList.add("internal-video--playing");
          if (this.playButton && this.noPlayBtn) {
            this.playButton.style.visibility = "hidden";
          }
        }).catch(_0x3c5321 => {
          this.classList.remove("internal-video--playing");
          if (this.playButton && this.noPlayBtn) {
            this.playButton.style.visibility = "visible";
          }
        });
      }
    } else {
      this.video.pause();
      this.classList.remove("internal-video--playing");
    }
  }
  endedVideo() {
    this.classList.remove("internal-video--playing");
  }
  toggleSound() {
    if (this.video.muted) {
      this.video.muted = false;
      this.classList.remove("internal-video--muted");
    } else {
      this.video.muted = true;
      this.classList.add("internal-video--muted");
    }
  }
  updateTimeline() {
    const _0x564ecf = this.video.currentTime / this.video.duration * 100;
    this.style.setProperty("--completed", _0x564ecf + "%");
  }
  hideSpinner() {
    this.classList.remove("internal-video--loading");
  }
  startDrag(_0x12eb09) {
    _0x12eb09.preventDefault();
    this.dragging = true;
    this.drag(_0x12eb09);
  }
  stopDrag() {
    this.dragging = false;
  }
  drag(_0x1e5c59) {
    if (!this.dragging) {
      return;
    }
    if (_0x1e5c59.touches) {
      _0x1e5c59 = _0x1e5c59.touches[0];
    }
    this.seekVideo(_0x1e5c59);
  }
  seekVideo(_0x49ade1) {
    const _0x43f629 = this.timeline.getBoundingClientRect();
    const _0x1c09ea = _0x49ade1.clientX - _0x43f629.left;
    const _0x24a51f = _0x1c09ea / _0x43f629.width;
    this.video.currentTime = _0x24a51f * this.video.duration;
  }
  showSpinner() {
    this.classList.add("internal-video--loading");
  }
  hideSpinner() {
    this.classList.remove("internal-video--loading");
  }
  handleIntersection(_0x3c034b) {
    _0x3c034b.forEach(_0x3df33d => {
      if (_0x3df33d.isIntersecting) {
        for (let _0x204093 of this.video.querySelectorAll("source[data-src]")) {
          _0x204093.setAttribute("src", _0x204093.getAttribute("data-src"));
          _0x204093.removeAttribute("data-src");
        }
        this.video.load();
        var _0x443bff = this.video.play();
        if (_0x443bff !== undefined) {
          _0x443bff.catch(_0x226faa => {
            if (_0x226faa.name === "NotAllowedError") {
              this.classList.remove("internal-video--playing");
              if (this.playButton && this.noPlayBtn) {
                this.playButton.style.visibility = "visible";
              }
            }
          }).then(() => {
            this.video.play();
          });
        }
        this.observer.disconnect();
      }
    });
  }
}
customElements.define("internal-video", InternalVideo);
class ComparisonSlider extends HTMLElement {
  constructor() {
    super();
    this.sliderOverlay = this.querySelector(".comparison-slider__overlay");
    this.sliderLine = this.querySelector(".comparison-slider__line");
    this.sliderInput = this.querySelector(".comparison-slider__input");
    this.sliderInput.addEventListener("input", this.handleChange.bind(this));
  }
  handleChange(_0xc5270) {
    const _0x4daed8 = _0xc5270.currentTarget.value;
    this.sliderOverlay.style.width = _0x4daed8 + "%";
    this.sliderLine.style.left = _0x4daed8 + "%";
  }
}
customElements.define("comparison-slider", ComparisonSlider);
class PromoPopup extends HTMLElement {
  constructor() {
    super();
    this.testMode = this.dataset.testMode === "true";
    this.secondsDelay = this.dataset.delaySeconds;
    this.daysFrequency = this.dataset.delayDays;
    this.modal = this.querySelector(".sign-up-popup-modal");
    this.timer = this.querySelector(".popup-modal__timer");
    this.timerDuration = this.dataset.timerDuration;
    this.closeBtns = this.querySelectorAll(".promp-popup__close-btn");
    this.overlay = document.querySelector(".sign-up-popup-overlay");
    this.storageKey = "promo-bar-data-" + window.location.host;
    if (!this.testMode) {
      if (localStorage.getItem(this.storageKey) === null) {
        this.openPopupModal();
      } else {
        const _0x4ab1d4 = JSON.parse(localStorage.getItem(this.storageKey));
        const _0xf4d831 = new Date(_0x4ab1d4.next_display_date);
        if (currentDate.getTime() > _0xf4d831.getTime()) {
          this.openPopupModal();
        }
      }
    } else if (this.timer) {
      this.displayPromoTimer();
    }
    this.closeBtns.forEach(_0x8daf5d => {
      _0x8daf5d.addEventListener("click", this.closeModal.bind(this));
    });
  }
  openPopupModal() {
    setTimeout(() => {
      this.modal.classList.add("popup-modal--active");
      this.overlay.classList.add("popup-overlay--active");
      const _0x19987e = addDays(currentDate, parseInt(this.daysFrequency));
      const _0x9d8ef6 = {
        next_display_date: _0x19987e,
        dismissed: false
      };
      localStorage.setItem(this.storageKey, JSON.stringify(_0x9d8ef6));
      if (this.timer) {
        this.displayPromoTimer();
      }
    }, parseInt(this.secondsDelay) * 1000 + 3000);
  }
  displayPromoTimer() {
    this.minutesSpan = this.querySelector(".popup-modal__timer__minutes");
    this.secondsSpan = this.querySelector(".popup-modal__timer__seconds");
    this.totalSeconds = parseFloat(this.timerDuration) * 60;
    this.updateTimer();
    const _0x2b3f21 = setInterval(() => {
      this.totalSeconds -= 1;
      this.updateTimer();
      if (this.totalSeconds <= 0) {
        this.totalSeconds = parseFloat(this.timerDuration) * 60 - 45;
      }
    }, 1000);
  }
  updateTimer() {
    let _0x58488c = Math.floor(this.totalSeconds / 60);
    if (_0x58488c.toString().length === 1) {
      _0x58488c = "0" + _0x58488c;
    }
    let _0x429d8f = this.totalSeconds % 60;
    if (_0x429d8f.toString().length === 1) {
      _0x429d8f = "0" + _0x429d8f;
    }
    this.minutesSpan.innerText = _0x58488c;
    this.secondsSpan.innerText = _0x429d8f;
  }
  closeModal() {
    this.modal.classList.remove("popup-modal--active");
    this.overlay.classList.remove("popup-overlay--active");
  }
}
customElements.define("promo-popup", PromoPopup);
class SectionsGroup extends HTMLElement {
  constructor() {
    super();
    this.sectionOneContainer = this.querySelector(".section-group__section-one-container");
    this.sectionTwoContainer = this.querySelector(".section-group__section-two-container");
    this.transferSections();
    document.addEventListener("shopify:section:load", this.transferSections.bind(this));
  }
  transferSections() {
    this.sectionOne = document.querySelector(this.dataset.sectionOneId + " .content-for-grouping");
    this.sectionTwo = document.querySelector(this.dataset.sectionTwoId + " .content-for-grouping");
    if (this.sectionOne && !this.sectionOneContainer.childNodes.length) {
      this.sectionOneContainer.appendChild(this.sectionOne);
    }
    if (this.sectionTwo && !this.sectionTwoContainer.childNodes.length) {
      this.sectionTwoContainer.appendChild(this.sectionTwo);
    }
  }
}
customElements.define("section-group", SectionsGroup);
class ClickableDiscount extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector(".clickable-discount__btn");
    this.button.addEventListener("click", this.handleClick.bind(this));
    if (this.dataset.applied === "true") {
      this.handleClick();
    } else {
      this.reapplyDiscountIfApplicable();
    }
  }
  handleClick() {
    this.dataset.loading = "true";
    this.button.disabled = true;
    this.dataset.error = "false";
    fetch("/discount/" + this.dataset.code).then(_0x593c0e => {
      if (!_0x593c0e.ok) {
        throw new Error("Error");
      }
      this.dataset.applied = "true";
      sessionStorage.setItem("discount-" + this.dataset.code + "-applied", "true");
    }).catch(_0x4352f6 => {
      this.dataset.error = "true";
      this.button.disabled = false;
    }).finally(() => {
      this.dataset.loading = "false";
    });
  }
  reapplyDiscountIfApplicable() {
    const _0x4a6eb0 = this.dataset.code;
    if (sessionStorage.getItem("discount-" + _0x4a6eb0 + "-applied")) {
      this.dataset.applied = "true";
      this.button.disabled = true;
      setTimeout(() => {
        fetch("/discount/" + _0x4a6eb0).catch(_0xbdc0c0 => {
          this.dataset.applied = "false";
          this.button.disabled = false;
        });
      }, 3000);
    }
  }
}
customElements.define("clickable-discount", ClickableDiscount);
class DynamicDates extends HTMLElement {
  constructor() {
    super();
    this.dateFormat = this.dataset.dateFormat;
    this.days = this.rearrangeDays(this.dataset.dayLabels.split(","));
    this.months = this.dataset.monthLabels.split(",");
    this.elementsToChange = this.querySelectorAll("[data-dynamic-date=\"true\"]");
    this.insertDates();
    document.addEventListener("shopify:section:load", _0x46e8ad => {
      this.insertDates();
    });
  }
  insertDates() {
    this.elementsToChange.forEach(_0x28811f => {
      const _0xd06060 = _0x28811f.dataset.text;
      const _0x1137a2 = parseInt(_0x28811f.dataset.minDays);
      const _0x301ff3 = parseInt(_0x28811f.dataset.maxDays);
      const _0x3bdad1 = addDays(currentDate, _0x1137a2);
      let _0x33b060 = "th";
      const _0x15e15e = _0x3bdad1.getDate();
      if (_0x15e15e === 1 || _0x15e15e === 21 || _0x15e15e === 31) {
        _0x33b060 = "st";
      } else if (_0x15e15e === 2 || _0x15e15e === 22) {
        _0x33b060 = "nd";
      } else if (_0x15e15e === 3 || _0x15e15e === 23) {
        _0x33b060 = "rd";
      }
      const _0x13905a = addDays(currentDate, _0x301ff3);
      let _0x19445a = "th";
      const _0x37bc83 = _0x13905a.getDate();
      if (_0x37bc83 === 1 || _0x37bc83 === 21 || _0x37bc83 === 31) {
        _0x19445a = "st";
      } else if (_0x37bc83 === 2 || _0x37bc83 === 22) {
        _0x19445a = "nd";
      } else if (_0x37bc83 === 3 || _0x37bc83 === 23) {
        _0x19445a = "rd";
      }
      let _0x125e1d;
      let _0x59a54d;
      if (this.dateFormat === "day_dd_mm") {
        _0x125e1d = this.days[_0x3bdad1.getDay()] + ", " + _0x3bdad1.getDate() + ". " + this.months[_0x3bdad1.getMonth()];
        _0x59a54d = this.days[_0x13905a.getDay()] + ", " + _0x13905a.getDate() + ". " + this.months[_0x13905a.getMonth()];
      } else if (this.dateFormat === "mm_dd") {
        _0x125e1d = this.months[_0x3bdad1.getMonth()] + " " + _0x3bdad1.getDate() + _0x33b060;
        _0x59a54d = this.months[_0x13905a.getMonth()] + " " + _0x13905a.getDate() + _0x19445a;
      } else if (this.dateFormat === "dd_mm") {
        _0x125e1d = _0x3bdad1.getDate() + ". " + this.months[_0x3bdad1.getMonth()];
        _0x59a54d = _0x13905a.getDate() + ". " + this.months[_0x13905a.getMonth()];
      } else if (this.dateFormat === "dd_mm_no_dot") {
        _0x125e1d = _0x3bdad1.getDate() + " " + this.months[_0x3bdad1.getMonth()];
        _0x59a54d = _0x13905a.getDate() + " " + this.months[_0x13905a.getMonth()];
      } else if (this.dateFormat === "day_dd_mm_numeric") {
        const _0x329e6f = String(_0x3bdad1.getDate()).length > 1 ? _0x3bdad1.getDate() : "0" + _0x3bdad1.getDate();
        const _0x55d4cb = String(_0x3bdad1.getMonth() + 1).length > 1 ? _0x3bdad1.getMonth() + 1 : "0" + (_0x3bdad1.getMonth() + 1);
        _0x125e1d = this.days[_0x3bdad1.getDay()] + ", " + _0x329e6f + ". " + _0x55d4cb + ".";
        const _0x5160e = String(_0x13905a.getDate()).length > 1 ? _0x13905a.getDate() : "0" + _0x13905a.getDate();
        const _0x33c5e4 = String(_0x13905a.getMonth() + 1).length > 1 ? _0x13905a.getMonth() + 1 : "0" + (_0x13905a.getMonth() + 1);
        _0x59a54d = this.days[_0x13905a.getDay()] + ", " + _0x5160e + ". " + _0x33c5e4 + ".";
      } else if (this.dateFormat === "dd_mm_numeric") {
        const _0x32ee03 = String(_0x3bdad1.getDate()).length > 1 ? _0x3bdad1.getDate() : "0" + _0x3bdad1.getDate();
        const _0x371630 = String(_0x3bdad1.getMonth() + 1).length > 1 ? _0x3bdad1.getMonth() + 1 : "0" + (_0x3bdad1.getMonth() + 1);
        _0x125e1d = _0x32ee03 + ". " + _0x371630 + ".";
        const _0x49f90e = String(_0x13905a.getDate()).length > 1 ? _0x13905a.getDate() : "0" + _0x13905a.getDate();
        const _0x26ea12 = String(_0x13905a.getMonth() + 1).length > 1 ? _0x13905a.getMonth() + 1 : "0" + (_0x13905a.getMonth() + 1);
        _0x59a54d = _0x49f90e + ". " + _0x26ea12 + ".";
      } else {
        _0x125e1d = this.days[_0x3bdad1.getDay()] + ", " + this.months[_0x3bdad1.getMonth()] + " " + _0x3bdad1.getDate() + _0x33b060;
        _0x59a54d = this.days[_0x13905a.getDay()] + ", " + this.months[_0x13905a.getMonth()] + " " + _0x13905a.getDate() + _0x19445a;
      }
      const _0x317e8c = _0xd06060.replace("[start_date]", _0x125e1d);
      const _0x29e5ed = _0x317e8c.replace("[end_date]", _0x59a54d);
      _0x28811f.innerHTML = _0x29e5ed;
    });
  }
  rearrangeDays(_0x560bf1) {
    _0x560bf1.unshift(_0x560bf1[6]);
    _0x560bf1.length = 7;
    return _0x560bf1;
  }
}
customElements.define("dynamic-dates", DynamicDates);
class StickyAtc extends HTMLElement {
  constructor() {
    super();
    this.isAfterScroll = this.dataset.afterScroll === "true";
    this.isScrollBtn = this.dataset.scrollBtn === "true";
    this.mainAtcBtn = document.querySelector("#ProductSubmitButton-" + this.dataset.section);
    this.floatingBtns = document.querySelectorAll(".floating-btn");
    this.footerSpacing();
    if (this.isAfterScroll) {
      if (this.mainAtcBtn) {
        this.checkATCScroll();
        document.addEventListener("scroll", this.checkATCScroll.bind(this));
      }
    } else {
      this.floatingBtns.forEach(_0x278fc6 => {
        _0x278fc6.style.setProperty("--sticky-atc-offset", this.offsetHeight + "px");
      });
    }
    if (this.isScrollBtn) {
      this.scrollBtn = this.querySelector(".sticky-atc__scroll-btn");
      this.scrollDestination = document.querySelector("" + this.dataset.scrollDestination.replace("id", this.dataset.section));
      if (this.scrollBtn && this.scrollDestination) {
        this.scrollBtn.addEventListener("click", this.handleScrollBtn.bind(this));
      }
    }
  }
  checkATCScroll() {
    if (window.scrollY > this.mainAtcBtn.offsetTop + this.mainAtcBtn.offsetHeight) {
      this.style.transform = "none";
      this.scrolledPast = true;
    } else {
      this.style.transform = "";
      this.scrolledPast = false;
    }
    this.floatingBtns.forEach(_0x3a749a => {
      if (this.scrolledPast) {
        _0x3a749a.style.setProperty("--sticky-atc-offset", this.offsetHeight + "px");
      } else {
        _0x3a749a.style.setProperty("--sticky-atc-offset", "0px");
      }
    });
  }
  handleScrollBtn() {
    const _0x1b9f9f = document.querySelector("sticky-header");
    const _0x4f9952 = _0x1b9f9f ? _0x1b9f9f.clientHeight : 0;
    window.scrollTo({
      top: this.scrollDestination.offsetTop - _0x4f9952 - 15,
      behavior: "smooth"
    });
  }
  footerSpacing() {
    let _0x14c30a = document.querySelector(".sticky-atc-footer-spacer");
    if (_0x14c30a) {
      return;
    }
    _0x14c30a = document.createElement("div");
    _0x14c30a.className = "sticky-atc-footer-spacer";
    _0x14c30a.style.height = this.clientHeight - 1 + "px";
    _0x14c30a.style.display = "block";
    const _0x162652 = document.querySelector(".footer");
    if (_0x162652) {
      _0x14c30a.style.background = window.getComputedStyle(_0x162652).background;
    }
    document.body.appendChild(_0x14c30a);
  }
}
customElements.define("sticky-atc", StickyAtc);
class BundleDeals extends HTMLElement {
  constructor() {
    super();
    this.productContainers = this.querySelectorAll(".bundle-deals__product-js");
    this.mediaItemContainers = this.querySelectorAll(".bundle-deals__media-item-container-js");
    this.mediaItemImgs = this.querySelectorAll(".bundle-deals__media-item-img-js");
    this.checkboxes = this.querySelectorAll(".bundle-deals__checkbox-js");
    this.variantPickers = this.querySelectorAll(".bundle-deals__variant-selects-js");
    this.skipNonExistent = this.dataset.skipNonExistent === "true";
    this.skipUnavailable = this.dataset.skipUnavailable === "true";
    this.prices = this.querySelectorAll(".bundle-deals__price-js");
    this.comparePrices = this.querySelectorAll(".bundle-deals__compare-price-js");
    this.totalPrice = this.querySelector(".bundle-deals__total-price-js");
    this.totalComparePrice = this.querySelector(".bundle-deals__total-compare-price-js");
    this.updatePrices = this.dataset.updatePrices === "true";
    this.percentageLeft = parseFloat(this.dataset.percentageLeft);
    this.fixedDiscount = parseFloat(this.dataset.fixedDiscount);
    this.currencySymbol = this.dataset.currencySymbol;
    this.moneyFormat = this.dataset.moneyFormat || "";
    this.selectedVariants = {
      id_1: null,
      id_2: null,
      id_3: null,
      id_4: null,
      id_5: null
    };
    this.formVariants = [];
    this.initIds();
    this.checkboxes.forEach(_0x1606e1 => {
      _0x1606e1.addEventListener("change", this.handleCheckboxChange.bind(this));
    });
    this.variantPickers.forEach(_0x6d2aea => {
      _0x6d2aea.addEventListener("change", this.handleSelectChange.bind(this));
    });
  }
  initIds() {
    this.checkboxes.forEach(_0x1fde25 => {
      this.selectedVariants[_0x1fde25.dataset.idIndex] = {
        id: _0x1fde25.dataset.id,
        price: _0x1fde25.dataset.price,
        comparePrice: _0x1fde25.dataset.comparePrice,
        checked: true
      };
    });
    this.updateFormIds();
  }
  handleCheckboxChange(_0x5a96fc) {
    const _0x2204be = _0x5a96fc.currentTarget;
    const _0x578ba4 = _0x2204be.checked;
    const _0x55a96a = parseInt(_0x2204be.dataset.index);
    this.selectedVariants[_0x2204be.dataset.idIndex].checked = _0x578ba4;
    const _0x33e1d9 = this.productContainers[_0x55a96a];
    const _0x1f790d = _0x33e1d9.querySelectorAll("select");
    if (_0x578ba4) {
      this.mediaItemContainers[_0x55a96a].classList.remove("bundle-deals__media-item--disabled");
      _0x33e1d9.classList.remove("bundle-deals__product--deselected");
      _0x1f790d.forEach(_0x438c85 => {
        _0x438c85.removeAttribute("disabled");
      });
    } else {
      this.mediaItemContainers[_0x55a96a].classList.add("bundle-deals__media-item--disabled");
      _0x33e1d9.classList.add("bundle-deals__product--deselected");
      _0x1f790d.forEach(_0x1a34c1 => {
        _0x1a34c1.setAttribute("disabled", "");
      });
    }
    this.updateFormIds();
    if (this.updatePrices) {
      this.updateTotalPrice();
    }
  }
  handleSelectChange(_0x13aab4) {
    const _0x1ed69b = _0x13aab4.currentTarget;
    const _0x524988 = parseInt(_0x1ed69b.dataset.index);
    const _0x54786b = Array.from(_0x1ed69b.querySelectorAll("select"), _0x3208cd => _0x3208cd.value);
    const _0x31fe06 = JSON.parse(_0x1ed69b.querySelector("[type=\"application/json\"]").textContent).filter(_0x5317d7 => _0x1ed69b.querySelector(":checked").value === _0x5317d7.option1);
    const _0x2a942a = [..._0x1ed69b.querySelectorAll(".select--small")];
    updateVariantStatuses(_0x31fe06, _0x2a942a);
    const _0x398f60 = JSON.parse(_0x1ed69b.querySelector("[type=\"application/json\"]").textContent).find(_0x5f1aab => {
      return !_0x5f1aab.options.map((_0x5db481, _0x4aa8f3) => {
        return _0x54786b[_0x4aa8f3] === _0x5db481;
      }).includes(false);
    });
    if (!_0x398f60) {
      if (this.skipNonExistent) {
        findAvailableVariant(_0x1ed69b, _0x54786b, false, true, this.skipUnavailable);
      }
      return;
    }
    if (this.skipUnavailable && !_0x398f60.available) {
      if (findAvailableVariant(_0x1ed69b, _0x54786b, false, true, true)) {
        return;
      }
    }
    let {
      price: _0x795c52,
      compare_at_price: _0x5c56e5,
      featured_image: _0x57a804
    } = _0x398f60;
    _0x795c52 = parseInt(_0x795c52);
    let _0x2369f9 = _0x5c56e5 ? parseInt(_0x5c56e5) : _0x795c52;
    const _0x2f0260 = _0x1ed69b.dataset.percentageLeft ?? 1;
    const _0x4b0f8b = _0x1ed69b.dataset.fixedDiscount ?? 0;
    _0x795c52 = _0x795c52 * _0x2f0260 - _0x4b0f8b;
    if (_0x57a804) {
      _0x57a804 = _0x57a804.src;
    }
    const _0x25283d = _0x398f60.id;
    this.selectedVariants[_0x1ed69b.dataset.idIndex].id = _0x25283d;
    this.selectedVariants[_0x1ed69b.dataset.idIndex].price = _0x795c52;
    this.selectedVariants[_0x1ed69b.dataset.idIndex].comparePrice = _0x2369f9;
    this.updateFormIds();
    if (this.updatePrices) {
      this.prices[_0x524988].innerHTML = this.formatPrice(_0x795c52);
      if (_0x2369f9 > _0x795c52) {
        this.comparePrices[_0x524988].innerHTML = this.formatPrice(_0x2369f9);
      } else {
        this.comparePrices[_0x524988].innerHTML = "";
      }
      this.updateTotalPrice();
    }
    if (_0x57a804 && _0x57a804.length > 0 && this.mediaItemImgs[_0x524988]) {
      this.mediaItemImgs[_0x524988].src = _0x57a804;
    }
  }
  formatPrice(_cents) {
    if (this.moneyFormat && /\{\{\s*amount\w*\s*\}\}/.test(this.moneyFormat)) {
      return formatMoney(Math.round(_cents), this.moneyFormat);
    }
    const _rounded = Math.round(_cents);
    return this.currencySymbol + (_rounded / 100).toFixed(_rounded % 100 === 0 ? 0 : 2);
  }
  updateFormIds() {
    const _0x3cef37 = [];
    const _0x160544 = this.selectedVariants;
    for (const _0x506718 in _0x160544) {
      const _0x1473fe = _0x160544[_0x506718];
      if (_0x1473fe != null && _0x1473fe.checked) {
        const _0x368194 = _0x3cef37.findIndex(_0x1b6adc => _0x1b6adc.id === _0x1473fe.id);
        if (_0x368194 < 0) {
          _0x3cef37.unshift({
            id: _0x1473fe.id,
            quantity: 1
          });
        } else {
          _0x3cef37[_0x368194].quantity += 1;
        }
      }
    }
    this.formVariants = _0x3cef37;
  }
  updateTotalPrice() {
    const _0x53fe27 = [];
    const _0x35cec6 = [];
    const _0x4f2166 = this.selectedVariants;
    for (const _0xe056cf in _0x4f2166) {
      const _0x8f368c = _0x4f2166[_0xe056cf];
      if (_0x8f368c != null && _0x8f368c.checked) {
        _0x53fe27.push(parseInt(_0x8f368c.price));
        _0x35cec6.push(parseInt(_0x8f368c.comparePrice));
      }
    }
    const _0x2f6b00 = _0x53fe27.reduce((_0x2e28e2, _0xe47d01) => _0x2e28e2 + _0xe47d01, 0);
    const _0x20c379 = _0x2f6b00 * this.percentageLeft - this.fixedDiscount;
    const _0x2689ee = _0x35cec6.reduce((_0x1c90cc, _0x324ae0) => _0x1c90cc + _0x324ae0, 0);
    this.totalPrice.innerHTML = this.formatPrice(_0x20c379);
    if (_0x2689ee > _0x20c379) {
      this.totalComparePrice.innerHTML = this.formatPrice(_0x2689ee);
    } else {
      this.totalComparePrice.innerHTML = "";
    }
  }
}
customElements.define("bundle-deals", BundleDeals);
class QuantityBreaks extends HTMLElement {
  constructor() {
    super();
    this.quantityGifts = document.getElementById("quantity-gifts-" + this.dataset.section);
    this.inputs = this.querySelectorAll("input[name=\"quantity\"]");
    this.labels = this.querySelectorAll(".quantity-break");
    this.jsonData = this.querySelector("[type=\"application/json\"]");
    this.hasVariants = this.jsonData.dataset.hasVariants === "true";
    this.selectedVariants = {
      input_1: [],
      input_2: [],
      input_3: [],
      input_4: [],
      input_5: [],
      input_6: []
    };
    this.updateUnavailable = this.dataset.updateUnavailable === "true";
    this.skipNonExistent = this.dataset.skipNonExistent === "true";
    this.skipUnavailable = this.dataset.skipUnavailable === "true";
    this.formVariants = [];
    this.selectedQuantity = 1;
    if (this.querySelector("input[checked]")) {
      this.selectedQuantity = parseInt(this.querySelector("input[checked]").value);
    }
    this.variantSelects = this.querySelectorAll(".quantity-break__selector-item");
    this.updatePrices = this.dataset.updatePrices === "true";
    this.moneyFormat = this.dataset.moneyFormat;
    if (this.hasVariants) {
      this.initVariants();
    }
    this.inputs.forEach(_0x17c7c0 => {
      _0x17c7c0.addEventListener("change", this.handleChange.bind(this));
    });
    this.variantSelects.forEach(_0x561f66 => {
      _0x561f66.addEventListener("change", this.handleSelectChange.bind(this));
    });
  }
  handleSelectChange(_0x4d5e8c) {
    const _0x3bd52d = _0x4d5e8c.currentTarget;
    const _0x562ef4 = Array.from(_0x3bd52d.querySelectorAll("select"), _0xb8d960 => _0xb8d960.value);
    if (this.updateUnavailable) {
      const _0x1a665e = this.getVariantData().filter(_0x478a3b => _0x3bd52d.querySelector(":checked").value === _0x478a3b.option1);
      const _0x35374d = [..._0x3bd52d.querySelectorAll(".select--small")];
      updateVariantStatuses(_0x1a665e, _0x35374d);
    }
    const _0x993c76 = this.getVariantData().find(_0x16cdd6 => {
      return !_0x16cdd6.options.map((_0x4e36e7, _0x1a5221) => {
        return _0x562ef4[_0x1a5221] === _0x4e36e7;
      }).includes(false);
    });
    if (!_0x993c76) {
      if (this.skipNonExistent) {
        findAvailableVariant(_0x3bd52d, _0x562ef4, false, true, this.skipUnavailable);
      }
      return;
    }
    if (this.skipUnavailable && !_0x993c76.available) {
      if (findAvailableVariant(_0x3bd52d, _0x562ef4, false, true, true)) {
        return;
      }
    }
    _0x3bd52d.dataset.selectedId = _0x993c76.id;
    const _0x2995f6 = _0x3bd52d.dataset.selectIndex;
    const _0x27c381 = _0x3bd52d.closest(".quantity-break");
    const _0x327068 = _0x27c381.dataset.input;
    this.selectedVariants[_0x327068][_0x2995f6] = _0x993c76.id;
    this.formVariants = this.selectedVariants[_0x327068];
    this.updateMedia(_0x993c76);
    if (!this.updatePrices) {
      return;
    }
    var _0x373115 = 0;
    var _0x4b1085 = 0;
    const _0x2a7525 = parseFloat(_0x27c381.dataset.quantity);
    const _0x14e716 = parseFloat(_0x27c381.dataset.percentageLeft);
    const _0x55c05e = parseFloat(_0x27c381.dataset.fixedDiscount);
    for (let _0x378c84 = 0; _0x378c84 < _0x2a7525; _0x378c84++) {
      const _0x5746a0 = parseInt(this.selectedVariants[_0x327068][_0x378c84]);
      const _0x2d25db = this.getVariantData().find(_0xfd8a97 => parseInt(_0xfd8a97.id) === _0x5746a0);
      if (!_0x2d25db) {
        return;
      }
      _0x373115 += _0x2d25db.price;
      if (_0x2d25db.compare_at_price && _0x2d25db.compare_at_price > _0x2d25db.price) {
        _0x4b1085 += _0x2d25db.compare_at_price;
      } else {
        _0x4b1085 += _0x2d25db.price;
      }
    }
    _0x373115 = _0x373115 * _0x14e716 - _0x55c05e;
    const _0x36bb56 = _0x4b1085 - _0x373115;
    const _0x2f6177 = Math.round(_0x36bb56 / 100) * 100;
    const _0x1b1848 = _0x373115 / _0x2a7525;
    const _0x332545 = _0x4b1085 / _0x2a7525;
    const _0x81a245 = formatMoney(_0x373115, this.moneyFormat, true);
    const _0x53f9fb = formatMoney(_0x4b1085, this.moneyFormat, true);
    const _0x54294f = formatMoney(_0x36bb56, this.moneyFormat, true);
    const _0x3eaf7d = formatMoney(_0x2f6177, this.moneyFormat, true);
    const _0x5ee6f0 = formatMoney(_0x1b1848, this.moneyFormat, true);
    const _0x49ed03 = formatMoney(_0x332545, this.moneyFormat, true);
    _0x27c381.querySelectorAll(".variant-price-update").forEach(_0x2f49a5 => {
      let _0x502380 = _0x2f49a5.dataset.text;
      _0x502380 = _0x502380.replace("[quantity]", _0x2a7525);
      _0x502380 = _0x502380.replace("[price]", _0x81a245);
      _0x502380 = _0x502380.replace("[compare_price]", _0x53f9fb);
      _0x502380 = _0x502380.replace("[amount_saved]", _0x54294f);
      _0x502380 = _0x502380.replace("[amount_saved_rounded]", _0x3eaf7d);
      _0x502380 = _0x502380.replace("[price_each]", _0x5ee6f0);
      _0x502380 = _0x502380.replace("[compare_price_each]", _0x49ed03);
      _0x2f49a5.innerHTML = _0x502380;
    });
    const _0x47a255 = _0x27c381.querySelector(".quantity-break__compare-price");
    if (_0x47a255) {
      if (_0x4b1085 > _0x373115) {
        _0x47a255.classList.remove("hidden");
      } else {
        _0x47a255.classList.add("hidden");
      }
    }
  }
  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.jsonData.textContent);
    return this.variantData;
  }
  initVariants() {
    if (!this.hasVariants) {
      return;
    }
    this.labels.forEach(_0x423d1f => {
      if (_0x423d1f.querySelector(".quantity-break__variants")) {
        let _0x474d30 = [];
        _0x423d1f.querySelectorAll(".quantity-break__selector-item").forEach(_0x389235 => {
          _0x474d30.push(_0x389235.dataset.selectedId);
        });
        this.selectedVariants[_0x423d1f.dataset.input] = _0x474d30;
      }
    });
    this.formVariants = [];
  }
  updateMedia(_0x56ff80) {
    if (!_0x56ff80) {
      return;
    }
    if (!_0x56ff80.featured_media) {
      return;
    }
    const _0x1e3eee = document.querySelectorAll("[id^=\"MediaGallery-" + this.dataset.section + "\"]");
    _0x1e3eee.forEach(_0x428c00 => _0x428c00.setActiveMedia(this.dataset.section + "-" + _0x56ff80.featured_media.id, true));
  }
  handleChange(_0x189094) {
    const _0x50d57a = parseInt(_0x189094.target.value);
    this.selectedQuantity = _0x50d57a;
    if (this.hasVariants) {
      this.formVariants = this.selectedVariants[_0x189094.target.dataset.input];
    }
    if (this.quantityGifts) {
      this.quantityGifts.unlockGifts(_0x50d57a);
    }
  }
}
customElements.define("quantity-breaks", QuantityBreaks);
function updateVariantStatuses(_0x397aa7, _0x1382fd) {
  _0x1382fd.forEach((_0x149843, _0x5243f1) => {
    if (_0x5243f1 === 0) {
      return;
    }
    const _0x19ce6d = [..._0x149843.querySelectorAll("option")];
    const _0xcf5706 = _0x1382fd[_0x5243f1 - 1].querySelector(":checked").value;
    const _0x586ce6 = _0x397aa7.filter(_0x54b82f => _0x54b82f.available && _0x54b82f["option" + _0x5243f1] === _0xcf5706).map(_0x6729c9 => _0x6729c9["option" + (_0x5243f1 + 1)]);
    const _0x3e24d5 = _0x397aa7.filter(_0x2fcb1b => _0x2fcb1b["option" + _0x5243f1] === _0xcf5706).map(_0x4229a8 => _0x4229a8["option" + (_0x5243f1 + 1)]);
    _0x19ce6d.forEach(_0x5b0c27 => {
      _0x5b0c27.classList.remove("unavailable", "non-existent");
      if (_0x3e24d5.includes(_0x5b0c27.getAttribute("value"))) {
        if (_0x586ce6.includes(_0x5b0c27.getAttribute("value"))) {
          _0x5b0c27.innerText = _0x5b0c27.getAttribute("value");
        } else {
          _0x5b0c27.innerText = window.variantStrings.unavailable_with_option.replace("[value]", _0x5b0c27.getAttribute("value"));
          _0x5b0c27.classList.add("unavailable");
        }
      } else {
        _0x5b0c27.innerText = window.variantStrings.unavailable_with_option.replace("[value]", _0x5b0c27.getAttribute("value"));
        _0x5b0c27.classList.add("non-existent");
      }
    });
  });
}
function findAvailableVariant(_0x4766cd, _0x39cecb, _0x38ae97 = true, _0x27b3bc = false, _0x5ef515 = false) {
  for (let _0x2d652b = _0x39cecb.length - 1; _0x2d652b >= 0; _0x2d652b--) {
    const _0x290cef = _0x38ae97 ? _0x4766cd.querySelector(".product-form__input:nth-child(" + (_0x2d652b + 1) + ")") : _0x4766cd.querySelectorAll(".select")[_0x2d652b];
    const _0x278af9 = _0x38ae97 ? _0x290cef.querySelector(".product-form__input__type").dataset.type : "dropdown";
    const _0x239ff3 = _0x278af9 === "dropdown" ? _0x290cef.querySelectorAll("option") : _0x290cef.querySelectorAll("input[type=\"radio\"]");
    let _0x17f790 = Array.from(_0x239ff3).findIndex(_0x1a2a46 => _0x1a2a46.value === _0x39cecb[_0x2d652b]);
    let _0x5bf574 = false;
    while (_0x17f790 < _0x239ff3.length - 1) {
      _0x17f790++;
      const _0x55d7b5 = _0x239ff3[_0x17f790];
      if ((!_0x27b3bc || !_0x55d7b5.classList.contains("non-existent")) && (!_0x5ef515 || !_0x55d7b5.classList.contains("unavailable"))) {
        _0x39cecb[_0x2d652b] = _0x55d7b5.value;
        _0x5bf574 = true;
        break;
      }
    }
    if (!_0x5bf574) {
      _0x17f790 = Array.from(_0x239ff3).findIndex(_0x4da98c => _0x4da98c.value === _0x39cecb[_0x2d652b]);
      while (_0x17f790 > 0) {
        _0x17f790--;
        const _0x2379b5 = _0x239ff3[_0x17f790];
        if ((!_0x27b3bc || !_0x2379b5.classList.contains("non-existent")) && (!_0x5ef515 || !_0x2379b5.classList.contains("unavailable"))) {
          _0x39cecb[_0x2d652b] = _0x2379b5.value;
          _0x5bf574 = true;
          break;
        }
      }
    }
    if (_0x5bf574) {
      if (_0x278af9 === "dropdown") {
        _0x290cef.querySelector(".select__select").value = _0x39cecb[_0x2d652b];
      } else {
        _0x290cef.querySelector("input[type=\"radio\"][value=\"" + _0x39cecb[_0x2d652b] + "\"]").checked = true;
      }
      _0x4766cd.dispatchEvent(new Event("change"));
      return true;
    }
  }
  return false;
}
class QuantityGifts extends HTMLElement {
  constructor() {
    super();
    this.gifts = this.querySelectorAll(".quantity-gift");
    this.quantityBreaks = document.getElementById("quantity-breaks-" + this.dataset.section);
    this.quantitySelector = document.getElementById("Quantity-Form--" + this.dataset.section);
    this.unlockedItems = [];
    this.initUnlock();
  }
  initUnlock() {
    let _0x415ec8 = 1;
    if (this.quantityBreaks) {
      _0x415ec8 = parseInt(this.quantityBreaks.selectedQuantity);
    } else if (this.quantitySelector) {
      const _0x19a9a8 = this.quantitySelector.querySelector("input[name=\"quantity\"]");
      _0x415ec8 = parseInt(_0x19a9a8.value);
    }
    this.unlockGifts(_0x415ec8);
  }
  unlockGifts(_0x11efaa) {
    this.unlockedItems = [];
    this.gifts.forEach(_0x5661de => {
      if (parseInt(_0x5661de.dataset.quantity) <= _0x11efaa) {
        _0x5661de.classList.add("quantity-gift--unlocked");
        _0x5661de.dataset.unlocked = "true";
        if (_0x5661de.dataset.product) {
          this.unlockedItems.unshift(_0x5661de.dataset.product);
        }
      } else {
        _0x5661de.classList.remove("quantity-gift--unlocked");
        _0x5661de.dataset.unlocked = "false";
      }
    });
  }
}
customElements.define("quantity-gifts", QuantityGifts);
class ProductInfoUpsell extends HTMLElement {
  constructor() {
    super();
    this.image = this.querySelector(".upsell__image__img");
    this.toggleBtn = this.querySelector(".upsell-toggle-btn");
    this.variantSelects = this.querySelector(".upsell__variant-picker");
    this.variantSelectElements = this.querySelectorAll(".select__select");
    this.jsonData = this.querySelector("[type=\"application/json\"]");
    this.productForm = this.querySelector("product-form");
    if (this.productForm) {
      this.idInput = this.productForm.querySelector("[name=\"id\"]");
    }
    this.skipNonExistent = this.dataset.skipNonExistent === "true";
    this.skipUnavailable = this.dataset.skipUnavailable === "true";
    this.updatePrices = this.dataset.updatePrices === "true";
    if (this.updatePrices) {
      this.price = parseInt(this.dataset.price);
      this.comparePrice = parseInt(this.dataset.comparePrice);
      this.priceSpan = this.querySelector(".upsell__price .regular-price");
      this.comparePriceSpan = this.querySelector(".upsell__price .compare-price");
      this.percentageLeft = parseFloat(this.dataset.percentageLeft);
      this.fixedDiscount = parseFloat(this.dataset.fixedDiscount);
      this.moneyFormat = this.dataset.moneyFormat;
      this.isMainOfferItem = this.dataset.mainOfferItem === "true";
      if (this.isMainOfferItem) {
        this.mainOfferContainer = document.querySelector("#MainBundleOffer-" + this.dataset.section);
      }
    }
    if (this.toggleBtn) {
      this.toggleBtn.addEventListener("click", this.handleToggle.bind(this));
    }
    if (this.variantSelects) {
      this.variantSelects.addEventListener("change", this.handleSelectChange.bind(this));
    }
  }
  handleToggle(_0x577b80) {
    if (_0x577b80.target.nodeName.toLowerCase() === "select" || _0x577b80.target.nodeName.toLowerCase() === "option") {
      return;
    }
    if (this.dataset.selected === "true") {
      this.dataset.selected = "false";
    } else {
      this.dataset.selected = "true";
    }
  }
  handleSelectChange(_0xda32ca) {
    const _0x16aa2a = _0xda32ca.currentTarget;
    const _0x21d323 = Array.from(_0x16aa2a.querySelectorAll("select"), _0x3e0074 => _0x3e0074.value);
    const _0x89ba60 = this.getVariantData().find(_0x1d2f7c => {
      return !_0x1d2f7c.options.map((_0x13be4f, _0x576409) => {
        return _0x21d323[_0x576409] === _0x13be4f;
      }).includes(false);
    });
    const _0x400ffe = this.getVariantData().filter(_0x3715ed => _0x16aa2a.querySelector(":checked").value === _0x3715ed.option1);
    const _0x13dc05 = [..._0x16aa2a.querySelectorAll("select")];
    updateVariantStatuses(_0x400ffe, _0x13dc05);
    if (!_0x89ba60) {
      if (this.skipNonExistent) {
        findAvailableVariant(_0x16aa2a, _0x21d323, false, true, this.skipUnavailable);
      }
      return;
    }
    if (this.skipUnavailable && !_0x89ba60.available) {
      if (findAvailableVariant(_0x16aa2a, _0x21d323, false, true, true)) {
        return;
      }
    }
    if (this.updatePrices) {
      this.price = _0x89ba60.price * this.percentageLeft - this.fixedDiscount;
      this.comparePrice = _0x89ba60.price;
      if (_0x89ba60.compare_at_price && _0x89ba60.compare_at_price > _0x89ba60.price) {
        this.comparePrice = _0x89ba60.compare_at_price;
      }
      displayPrices(this.price, this.comparePrice, this.priceSpan, this.comparePriceSpan, this.moneyFormat);
    }
    if (this.image && _0x89ba60.featured_image) {
      this.image.src = _0x89ba60.featured_image.src;
    }
    this.updateId(_0x89ba60.id);
    if (this.isMainOfferItem && this.mainOfferContainer.updateTotalPrices) {
      this.mainOfferContainer.updateTotalPrices();
    }
  }
  updateId(_0x59d8a0) {
    this.dataset.id = _0x59d8a0;
    if (this.idInput) {
      this.idInput.value = _0x59d8a0;
    }
  }
  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.jsonData.textContent);
    return this.variantData;
  }
}
customElements.define("product-info-upsell", ProductInfoUpsell);
class CartDrawerUpsell extends ProductInfoUpsell {
  constructor() {
    super();
    this.cartDrawer = document.querySelector("cart-drawer");
    this.cartItems = this.cartDrawer.querySelector("cart-drawer-items");
    this.classicAddButton = this.querySelector(".upsell__add-btn");
  }
  handleToggle(_0x11e8c8) {
    if (_0x11e8c8.target.nodeName.toLowerCase() === "select" || _0x11e8c8.target.nodeName.toLowerCase() === "option") {
      return;
    }
    if (this.dataset.selected === "true") {
      this.dataset.selected = "false";
      this.removeFromCart();
    } else {
      this.dataset.selected = "true";
      this.addToCart();
    }
  }
  addRemoveFromCart() {
    if (this.dataset.selected === "true" && !this.cartDrawer.classList.contains("is-empty")) {
      this.addToCart();
    } else {
      this.removeFromCart();
    }
  }
  addToCart() {
    const _0x55a010 = this.cartDrawer.querySelector(".cart-item--product-" + this.dataset.handle);
    if (_0x55a010) {
      return;
    }
    if (this.toggleBtn) {
      this.toggleBtn.setAttribute("disabled", "");
    }
    this.variantSelectElements.forEach(_0x5169d3 => {
      _0x5169d3.setAttribute("disabled", "");
    });
    this.productForm.handleSubmit();
  }
  removeFromCart() {
    const _0x36eb30 = this.cartDrawer.querySelector(".cart-item--product-" + this.dataset.handle);
    if (!_0x36eb30 || !this.cartItems) {
      return;
    }
    if (this.toggleBtn) {
      this.toggleBtn.setAttribute("disabled", "");
    }
    this.variantSelectElements.forEach(_0x34465b => {
      _0x34465b.setAttribute("disabled", "");
    });
    this.cartItems.updateQuantity(_0x36eb30.dataset.index, 0);
  }
  updateId(_0x325f25) {
    this.dataset.id = _0x325f25;
    this.idInput.value = _0x325f25;
    if (this.classicAddButton) {
      return;
    }
    if (this.dataset.selected === "true") {
      if (this.selectTimeout) {
        clearTimeout(this.selectTimeout);
      }
      this.removeFromCart();
      const _0x1e62b2 = _0x4c9b2f => {
        if (_0x4c9b2f.detail.handle === "handle") {
          this.addToCart();
          document.removeEventListener("cartQuantityUpdated", _0x1e62b2);
        }
      };
      document.addEventListener("cartQuantityUpdated", _0x1e62b2);
    }
  }
  getUpdateRequired() {
    const _0x48719d = this.cartDrawer.querySelector(".cart-item--product-" + this.dataset.handle);
    let _0x5093bc = false;
    if (_0x48719d && this.dataset.selected === "false") {
      _0x5093bc = true;
    } else if (!_0x48719d && this.dataset.selected === "true") {
      _0x5093bc = true;
    }
    return _0x5093bc;
  }
}
customElements.define("cart-drawer-upsell", CartDrawerUpsell);
function displayPrices(_0x5433f2, _0x5a911e, _0xae9488, _0x1544c4, _0x53ab1d) {
  if (!_0x53ab1d) {
    return;
  }
  if (_0x5433f2 && _0xae9488) {
    var _0x262365 = formatMoney(_0x5433f2, _0x53ab1d);
    _0xae9488.innerHTML = _0x262365;
  }
  if (_0x5a911e && _0x1544c4) {
    var _0x3cd18c = formatMoney(_0x5a911e, _0x53ab1d);
    _0x1544c4.innerHTML = _0x3cd18c;
    if (_0x5a911e > _0x5433f2) {
      _0x1544c4.classList.remove("hidden");
    } else {
      _0x1544c4.classList.add("hidden");
    }
  }
}
function formatMoney(_0x5d674f, _0x36713a, _0x527d5b = false) {
  if (typeof _0x5d674f == "string") {
    _0x5d674f = _0x5d674f.replace(".", "");
  }
  var _0x342c4a = "";
  var _0x472aba = /\{\{\s*(\w+)\s*\}\}/;
  var _0x1223b1 = _0x36713a;
  function _0x558743(_0x5becf8, _0x47add4) {
    if (typeof _0x5becf8 == "undefined") {
      return _0x47add4;
    } else {
      return _0x5becf8;
    }
  }
  function _0x298661(_0x346fe5, _0x4ba8a4, _0x588965, _0x59ec6b) {
    _0x4ba8a4 = _0x558743(_0x4ba8a4, 2);
    _0x588965 = _0x558743(_0x588965, ",");
    _0x59ec6b = _0x558743(_0x59ec6b, ".");
    if (isNaN(_0x346fe5) || _0x346fe5 == null) {
      return 0;
    }
    _0x346fe5 = (_0x346fe5 / 100).toFixed(_0x4ba8a4);
    var _0x35379c = _0x346fe5.split(".");
    var _0xdcba20 = _0x35379c[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + _0x588965);
    var _0x9f24d7 = _0x35379c[1] ? _0x59ec6b + _0x35379c[1] : "";
    if (_0x527d5b && _0x9f24d7 === _0x59ec6b + "00") {
      _0x9f24d7 = "";
    }
    return _0xdcba20 + _0x9f24d7;
  }
  switch (_0x1223b1.match(_0x472aba)[1]) {
    case "amount":
      _0x342c4a = _0x298661(_0x5d674f, 2);
      break;
    case "amount_no_decimals":
      _0x342c4a = _0x298661(_0x5d674f, 0);
      break;
    case "amount_with_comma_separator":
      _0x342c4a = _0x298661(_0x5d674f, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      _0x342c4a = _0x298661(_0x5d674f, 0, ".", ",");
      break;
    case "amount_with_space_separator":
      _0x342c4a = _0x298661(_0x5d674f, 2, " ", ",");
      break;
    case "amount_no_decimals_with_space_separator":
      _0x342c4a = _0x298661(_0x5d674f, 0, " ");
      break;
    case "amount_with_period_and_space_separator":
      _0x342c4a = _0x298661(_0x5d674f, 2, " ", ".");
      break;
    case "amount_with_apostrophe_separator":
      _0x342c4a = _0x298661(_0x5d674f, 2, "'", ".");
      break;
  }
  return _0x1223b1.replace(_0x472aba, _0x342c4a);
}
class CartDrawerGift extends CartDrawerUpsell {
  constructor() {
    super();
  }
}
customElements.define("cart-drawer-gift", CartDrawerGift);
function initToggleUpsells() {
  const _0x9ae195 = document.querySelector("cart-drawer");
  if (_0x9ae195) {
    _0x9ae195.querySelectorAll("cart-drawer-upsell[data-toggle=\"true\"], cart-drawer-gift").forEach(_0x10f764 => {
      if (_0x10f764.addRemoveFromCart) {
        _0x10f764.addRemoveFromCart();
      }
    });
  }
}
initToggleUpsells();
class MainBundleOffer extends HTMLElement {
  constructor() {
    super();
    this.offerItems = this.querySelectorAll(".main-offer-item");
    this.updatePrices = this.dataset.updatePrices === "true";
    if (this.updatePrices) {
      this.priceSpan = this.querySelector(".bundle-deals__total-price-js");
      this.comparePriceSpan = this.querySelector(".bundle-deals__total-compare-price-js");
      this.percentageLeft = parseFloat(this.dataset.percentageLeft);
      this.fixedDiscount = parseFloat(this.dataset.fixedDiscount);
      this.moneyFormat = this.dataset.moneyFormat;
    }
  }
  updateTotalPrices() {
    if (!this.updatePrices) {
      return;
    }
    var _0x53c6d4 = 0;
    var _0x4c8729 = 0;
    for (let _0x2e9b06 = 0; _0x2e9b06 < this.offerItems.length; _0x2e9b06++) {
      _0x53c6d4 += parseInt(this.offerItems[_0x2e9b06].price);
      _0x4c8729 += parseInt(this.offerItems[_0x2e9b06].comparePrice);
    }
    _0x53c6d4 = _0x53c6d4 * this.percentageLeft - this.fixedDiscount;
    displayPrices(_0x53c6d4, _0x4c8729, this.priceSpan, this.comparePriceSpan, this.moneyFormat);
  }
}
customElements.define("main-bundle-offer", MainBundleOffer);
class CustomProductField extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.fieldName = this.dataset.name;
    this.input = this.querySelector("[type=\"text\"], [type=\"number\"], textarea");
    this.inputRadios = this.querySelectorAll("[type=\"radio\"]");
    this.select = this.querySelector(".select__select");
    this.productForm = document.getElementById("product-form-" + this.dataset.section);
    this.prevValue = this.dataset.defaultValue;
    this.isRequired = this.dataset.required === "true";
    this.isText = true;
    this.notMain = this.dataset.notMain === "true";
    if (this.dataset.type === "select" || this.dataset.type === "pills") {
      this.isText = false;
    }
    this.createInputs();
    if (this.isRequired && this.isText) {
      this.isValid = true;
      this.atcButtons = this.notMain ? document.querySelectorAll(".featured-product-atc-" + this.dataset.section) : document.querySelectorAll(".main-product-atc");
      this.mainAtcButton = this.productForm.querySelector("#ProductSubmitButton-" + this.dataset.section);
      this.mainAtcBtnLabel = this.mainAtcButton.querySelector(".main-atc__label");
      this.mainAtcBtnError = this.mainAtcButton.querySelector(".main-atc__error");
      this.atcErrorMsg = this.dataset.atcErrorMsg;
      this.mainAtcButton.dataset.requiredFields = parseInt(this.mainAtcButton.dataset.requiredFields) + 1;
      this.mainAtcBtnError.innerHTML = this.atcErrorMsg;
      this.applyStickyAtcError = this.dataset.applyStickyAtcError === "true";
      this.stickyAtcButton = document.querySelector("#sticky-atc-" + this.dataset.section);
      if (this.applyStickyAtcError && this.stickyAtcButton) {
        this.stickyAtcBtnLabel = this.stickyAtcButton.querySelector(".sticky-atc__label");
        this.stickyAtcBtnError = this.stickyAtcButton.querySelector(".sticky-atc__error");
        this.stickyAtcBtnError.innerHTML = this.atcErrorMsg;
      }
      this.validateValue(this.prevValue, null);
    }
    if (this.input) {
      this.input.addEventListener("input", this.handleChange.bind(this));
    }
    this.inputRadios.forEach(_0x5af50d => {
      _0x5af50d.addEventListener("input", this.handleChange.bind(this));
    });
    if (this.select) {
      this.select.addEventListener("change", this.handleChange.bind(this));
    }
  }
  handleChange(_0x4cae5a) {
    const _0x581258 = _0x4cae5a.target.value.trim();
    if (_0x4cae5a.target.checkValidity()) {
      this.prevValue = _0x581258;
    } else {
      _0x4cae5a.target.value = this.prevValue;
      return;
    }
    this.dataset.value = _0x581258;
    this.productFormInput.value = _0x581258;
    if (this.isRequired && this.isText) {
      this.validateValue(_0x581258, _0x4cae5a.target);
    }
  }
  validateValue(_0x15827b, _0x2bc2de) {
    const _0x44a422 = _0x15827b.length > 0 ? true : false;
    if (_0x44a422 === this.isValid) {
      return;
    }
    this.isValid = _0x44a422;
    if (_0x2bc2de) {
      if (this.isValid) {
        _0x2bc2de.classList.remove("input--error");
        this.mainAtcButton.dataset.validFields = parseInt(this.mainAtcButton.dataset.validFields) + 1;
      } else {
        _0x2bc2de.classList.add("input--error");
        this.mainAtcButton.dataset.validFields = parseInt(this.mainAtcButton.dataset.validFields) - 1;
      }
    }
    const _0x271deb = this.mainAtcButton.dataset.validFields === this.mainAtcButton.dataset.requiredFields;
    const _0x4b44be = this.mainAtcButton.dataset.unavailable === "true";
    this.atcButtons.forEach(_0x49815e => {
      if (_0x271deb && !_0x4b44be) {
        _0x49815e.removeAttribute("disabled");
      } else {
        _0x49815e.setAttribute("disabled", "");
      }
    });
    if (this.atcErrorMsg.length === 0) {
      return;
    }
    if (_0x271deb) {
      this.mainAtcBtnLabel.style.display = "";
      this.mainAtcBtnError.style.display = "none";
      if (this.applyStickyAtcError && this.stickyAtcButton) {
        this.stickyAtcBtnLabel.style.display = "";
        this.stickyAtcBtnError.style.display = "none";
      }
    } else {
      this.mainAtcBtnLabel.style.display = "none";
      this.mainAtcBtnError.style.display = "";
      if (this.applyStickyAtcError && this.stickyAtcButton) {
        this.stickyAtcBtnLabel.style.display = "none";
        this.stickyAtcBtnError.style.display = "";
      }
    }
  }
  createInputs() {
    this.productFormInput = document.createElement("input");
    this.productFormInput.setAttribute("type", "hidden");
    this.productFormInput.setAttribute("name", "properties[" + this.fieldName + "]");
    this.productFormInput.value = this.dataset.defaultValue;
    this.productForm.appendChild(this.productFormInput);
  }
}
customElements.define("custom-product-field", CustomProductField);
class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.secondarySelectSelector = "StickyAtcVariantPicker-";
    this.secondarySelect = document.getElementById("" + this.secondarySelectSelector + this.dataset.section);
    this.isSecondary = false;
    this.QuantityBreaks = document.getElementById("quantity-breaks-" + this.dataset.section);
    this.hasQuantityBreaksPicker = this.dataset.hasQuantityBreaksPicker === "true";
    this.prependMedia = this.dataset.disablePrepend != "true";
    this.filtering = this.dataset.hasFiltering === "true";
    this.skipNonExistent = this.dataset.skipNonExistent === "true";
    this.skipUnavailable = this.dataset.skipUnavailable === "true";
    if (this.hasQuantityBreaksPicker) {
      this.quantityBreaksPickerStyle = this.dataset.quantityBreaksPickerStyle;
      this.quantityBreaksPickerDisplayedImages = this.dataset.quantityBreaksPickerDisplayedImages;
    }
    this.addEventListener("change", this.onVariantChange);
  }
  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();
    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      if (this.skipNonExistent && findAvailableVariant(this, this.options, true, true, this.skipUnavailable)) {
        return;
      }
      this.setUnavailable();
    } else {
      if (this.skipUnavailable && !this.currentVariant.available) {
        if (findAvailableVariant(this, this.options, true, true, true)) {
          return;
        }
      }
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }
  updateOptions() {
    const _0x5bc470 = [];
    this.querySelectorAll(".product-form__input").forEach(_0x51ecb9 => {
      let _0x312979;
      const _0x42502c = _0x51ecb9.querySelector(".product-form__input__type").dataset.type;
      if (_0x42502c == "dropdown" || _0x42502c == "dropdwon") {
        _0x312979 = _0x51ecb9.querySelector(".select__select").value;
      } else {
        _0x312979 = _0x51ecb9.querySelector("input[type=\"radio\"]:checked").value;
      }
      _0x5bc470.push(_0x312979);
    });
    this.options = _0x5bc470;
  }
  updateMasterId() {
    this.currentVariant = this.getVariantData().find(_0x286f1b => {
      return !_0x286f1b.options.map((_0x42ccc7, _0xf23e55) => {
        return this.options[_0xf23e55] === _0x42ccc7;
      }).includes(false);
    });
  }
  updateMedia() {
    if (!this.currentVariant) {
      return;
    }
    if (!this.currentVariant.featured_media) {
      return;
    }
    const _0x4cd623 = document.querySelectorAll("[id^=\"MediaGallery-" + this.dataset.section + "\"]");
    _0x4cd623.forEach(_0x4ed5bc => _0x4ed5bc.setActiveMedia(this.dataset.section + "-" + this.currentVariant.featured_media.id, this.prependMedia, this.filtering, this.currentVariant));
    const _0x30615d = document.querySelector("#ProductModal-" + this.dataset.section + " .product-media-modal__content");
    if (!_0x30615d) {
      return;
    }
    const _0x489aed = _0x30615d.querySelector("[data-media-id=\"" + this.currentVariant.featured_media.id + "\"]");
    _0x30615d.prepend(_0x489aed);
  }
  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") {
      return;
    }
    window.history.replaceState({}, "", this.dataset.url + "?variant=" + this.currentVariant.id);
  }
  updateShareUrl() {
    const _0x2382a5 = document.getElementById("Share-" + this.dataset.section);
    if (!_0x2382a5 || !_0x2382a5.updateUrl) {
      return;
    }
    _0x2382a5.updateUrl("" + window.shopUrl + this.dataset.url + "?variant=" + this.currentVariant.id);
  }
  updateVariantInput() {
    const _0x1d2b8f = document.querySelectorAll("#product-form-" + this.dataset.section + ", #product-form-installment-" + this.dataset.section);
    _0x1d2b8f.forEach(_0x266dbe => {
      const _0x5ee00d = _0x266dbe.querySelector("input[name=\"id\"]");
      _0x5ee00d.value = this.currentVariant.id;
      _0x5ee00d.dispatchEvent(new Event("change", {
        bubbles: true
      }));
    });
  }
  updateVariantStatuses() {
    const _0xcb7872 = this.variantData.filter(_0x2b9a45 => this.querySelector(":checked").value === _0x2b9a45.option1);
    let _0x403722;
    if (this.isSecondary && this.secondarySelect) {
      _0x403722 = [...this.secondarySelect.querySelectorAll(".product-form__input")];
    } else {
      _0x403722 = [...this.querySelectorAll(".product-form__input")];
    }
    _0x403722.forEach((_0x4e1f1c, _0xb0a55b) => {
      if (_0xb0a55b === 0) {
        return;
      }
      const _0xbcf2f5 = [..._0x4e1f1c.querySelectorAll("input[type=\"radio\"], .select__select option")];
      const _0x271033 = _0x403722[_0xb0a55b - 1].querySelector(":checked").value;
      const _0x4f8583 = _0xcb7872.filter(_0x23ee9d => _0x23ee9d.available && _0x23ee9d["option" + _0xb0a55b] === _0x271033).map(_0x5e189d => _0x5e189d["option" + (_0xb0a55b + 1)]);
      const _0x269dca = _0xcb7872.filter(_0x3b2db4 => _0x3b2db4["option" + _0xb0a55b] === _0x271033).map(_0x529073 => _0x529073["option" + (_0xb0a55b + 1)]);
      this.setInputAvailability(_0xbcf2f5, _0x4f8583, _0x269dca);
    });
  }
  setInputAvailability(_0x60a055, _0x23c137, _0x2df9bd) {
    _0x60a055.forEach(_0x271def => {
      _0x271def.classList.remove("unavailable", "non-existent", "disabled");
      const _0x276fed = _0x271def.getAttribute("value");
      let _0xe8e120 = null;
      if (_0x271def.dataset.swatch === "true") {
        _0xe8e120 = _0x271def.closest(".color-swatch");
      }
      if (_0xe8e120) {
        _0xe8e120.classList.remove("unavailable", "non-existent", "disabled");
      }
      if (_0x2df9bd.includes(_0x276fed)) {
        if (_0x23c137.includes(_0x276fed)) {
          if (_0x271def.nodeName === "OPTION") {
            _0x271def.innerText = _0x276fed;
          } else {
            _0x271def.classList.remove("disabled");
            if (_0xe8e120) {
              _0xe8e120.classList.remove("disabled");
            }
          }
        } else if (_0x271def.nodeName === "OPTION") {
          _0x271def.innerText = window.variantStrings.unavailable_with_option.replace("[value]", _0x276fed);
          _0x271def.classList.add("unavailable");
        } else {
          _0x271def.classList.add("disabled", "unavailable");
          if (_0xe8e120) {
            _0xe8e120.classList.add("disabled", "unavailable");
          }
        }
      } else if (_0x271def.nodeName === "OPTION") {
        _0x271def.innerText = window.variantStrings.unavailable_with_option.replace("[value]", _0x276fed);
        _0x271def.classList.add("non-existent");
      } else {
        _0x271def.classList.add("disabled", "non-existent");
        if (_0xe8e120) {
          _0xe8e120.classList.add("disabled", "non-existent");
        }
      }
    });
  }
  updatePickupAvailability() {
    const _0x3ee894 = document.querySelector("pickup-availability");
    if (!_0x3ee894) {
      return;
    }
    if (this.currentVariant && this.currentVariant.available) {
      if (_0x3ee894.fetchAvailability) {
        _0x3ee894.fetchAvailability(this.currentVariant.id);
      }
    } else {
      _0x3ee894.removeAttribute("available");
      _0x3ee894.innerHTML = "";
    }
  }
  removeErrorMessage() {
    const _0x3efb05 = this.closest("section");
    if (!_0x3efb05) {
      return;
    }
    const _0x2f43dc = _0x3efb05.querySelector("product-form");
    if (_0x2f43dc) {
      _0x2f43dc.handleErrorMessage();
    }
  }
  renderProductInfo() {
    const _0x580aa3 = this.currentVariant.id;
    const _0x4ba5ed = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
    fetch(this.dataset.url + "?variant=" + _0x580aa3 + "&section_id=" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section)).then(_0x2221ef => _0x2221ef.text()).then(_0x3b1503 => {
      if (this.currentVariant.id !== _0x580aa3) {
        return;
      }
      const _0x5a9c7a = new DOMParser().parseFromString(_0x3b1503, "text/html");
      const _0x20402e = document.getElementById("price-" + this.dataset.section);
      const _0x37a798 = _0x5a9c7a.getElementById("price-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section));
      const _0x16c253 = document.getElementById("sticky-atc-separate-price-" + this.dataset.section);
      const _0x5c6640 = _0x5a9c7a.getElementById("sticky-atc-separate-price-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section));
      const _0x4c0d48 = document.getElementById("sticky-atc-price-" + this.dataset.section);
      const _0xf3e475 = _0x5a9c7a.getElementById("sticky-atc-price-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section));
      const _0x394677 = document.getElementById("sticky-atc-image-" + this.dataset.section);
      const _0x564bb7 = _0x5a9c7a.getElementById("sticky-atc-image-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section));
      const _0x32b2f7 = document.getElementById("main-atc-price-" + this.dataset.section);
      const _0x341efe = _0x5a9c7a.getElementById("main-atc-price-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section));
      const _0x4a8e94 = document.querySelectorAll("[id^=\"custom-label-" + this.dataset.section + "\"]");
      const _0x11148d = _0x5a9c7a.querySelectorAll("[id^=\"custom-label-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section) + "\"]");
      const _0x1723de = _0x5a9c7a.getElementById("Sku-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section));
      const _0x432b5d = document.getElementById("Sku-" + this.dataset.section);
      const _0x1bf2d5 = _0x5a9c7a.getElementById("Inventory-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section));
      const _0x4159ba = document.getElementById("Inventory-" + this.dataset.section);
      if (_0x20402e && _0x37a798) {
        _0x20402e.innerHTML = _0x37a798.innerHTML;
      }
      if (_0x16c253 && _0x5c6640) {
        _0x16c253.innerHTML = _0x5c6640.innerHTML;
      }
      if (_0x4c0d48 && _0xf3e475) {
        _0x4c0d48.innerHTML = _0xf3e475.innerHTML;
      }
      if (_0x394677 && _0x564bb7) {
        _0x394677.src = _0x564bb7.src;
      }
      if (_0x341efe && _0x32b2f7) {
        _0x32b2f7.innerHTML = _0x341efe.innerHTML;
      }
      if (_0x4a8e94 && _0x11148d) {
        for (var _0x189553 = 0; _0x189553 < _0x4a8e94.length; _0x189553++) {
          _0x4a8e94[_0x189553].innerHTML = _0x11148d[_0x189553].innerHTML;
        }
      }
      if (_0x1bf2d5 && _0x4159ba) {
        _0x4159ba.innerHTML = _0x1bf2d5.innerHTML;
      }
      if (_0x1723de && _0x432b5d) {
        _0x432b5d.innerHTML = _0x1723de.innerHTML;
        _0x432b5d.classList.toggle("visibility-hidden", _0x1723de.classList.contains("visibility-hidden"));
      }
      if (this.QuantityBreaks) {
        const _0x64f232 = _0x5a9c7a.getElementById("quantity-breaks-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section));
        const _0x51ce6b = this.QuantityBreaks.querySelectorAll(".dynamic-price");
        const _0x1fbd3b = _0x64f232.querySelectorAll(".dynamic-price");
        for (let _0x2788f3 = 0; _0x2788f3 < _0x51ce6b.length; _0x2788f3++) {
          _0x51ce6b[_0x2788f3].innerHTML = _0x1fbd3b[_0x2788f3].innerHTML;
        }
        if (this.QuantityBreaks.hasVariants) {
          this.QuantityBreaks.variantSelects.forEach(_0x42d672 => {
            _0x42d672.dataset.selectedId = this.currentVariant.id;
          });
          const _0x186dc8 = this.QuantityBreaks.querySelectorAll(".quantity-break__variant-select");
          const _0x101d36 = _0x64f232.querySelectorAll(".quantity-break__variant-select");
          for (let _0x19b5b2 = 0; _0x19b5b2 < _0x186dc8.length; _0x19b5b2++) {
            _0x186dc8[_0x19b5b2].innerHTML = _0x101d36[_0x19b5b2].innerHTML;
          }
          this.QuantityBreaks.initVariants();
        }
        ;
      }
      if (this.hasQuantityBreaksPicker) {
        const _0x4e1c1a = _0x5a9c7a.getElementById("variant-selects-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section));
        const _0x47e8b5 = this.querySelectorAll(".dynamic-price");
        const _0x559ebb = _0x4e1c1a.querySelectorAll(".dynamic-price");
        for (let _0x308e4a = 0; _0x308e4a < _0x47e8b5.length; _0x308e4a++) {
          _0x47e8b5[_0x308e4a].innerHTML = _0x559ebb[_0x308e4a].innerHTML;
        }
        if (this.quantityBreaksPickerStyle === "vertical" && this.quantityBreaksPickerDisplayedImages === "variant_images") {
          const _0x248d95 = this.querySelectorAll(".quantity-break__image img");
          const _0x19ea39 = _0x4e1c1a.querySelectorAll(".quantity-break__image img");
          for (let _0xbfe380 = 0; _0xbfe380 < _0x248d95.length; _0xbfe380++) {
            _0x248d95[_0xbfe380].src = _0x19ea39[_0xbfe380].src;
          }
        }
      }
      if (this.secondarySelect) {
        const _0x1fe7b0 = _0x5a9c7a.getElementById("" + this.secondarySelectSelector + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section));
        if (_0x1fe7b0) {
          this.secondarySelect.innerHTML = _0x1fe7b0.innerHTML;
        }
      }
      const _0x676fee = document.getElementById("price-" + this.dataset.section);
      if (_0x676fee) {
        _0x676fee.classList.remove("visibility-hidden");
      }
      this.dataset.options = this.currentVariant.options.join(",");
      if (_0x4159ba) {
        _0x4159ba.classList.toggle("visibility-hidden", _0x1bf2d5.innerText === "");
      }
      const _0x303a90 = _0x5a9c7a.getElementById("ProductSubmitButton-" + _0x4ba5ed);
      this.toggleAddButton(_0x303a90 ? _0x303a90.hasAttribute("disabled") : true, window.variantStrings.soldOut);
      publish(PUB_SUB_EVENTS.variantChange, {
        data: {
          sectionId: _0x4ba5ed,
          html: _0x5a9c7a,
          variant: this.currentVariant
        }
      });
    });
  }
  toggleAddButton(_0x1981da = true, _0x3d7483, _0x300975 = true) {
    const _0x90b1cc = document.getElementById("product-form-" + this.dataset.section);
    if (!_0x90b1cc) {
      return;
    }
    const _0x2492d7 = _0x90b1cc.querySelector("[name=\"add\"]");
    const _0x168eb9 = document.querySelectorAll(".main-product-atc");
    var _0x1ae2c2 = _0x90b1cc.querySelector(".main-atc__label__text");
    if (!_0x1ae2c2) {
      _0x1ae2c2 = _0x90b1cc.querySelector(".main-atc__label");
    }
    const _0x36b277 = _0x90b1cc.querySelector(".main-atc-price");
    if (!_0x2492d7) {
      return;
    }
    if (_0x1981da) {
      _0x2492d7.setAttribute("disabled", "disabled");
      _0x2492d7.setAttribute("data-unavailable", "true");
      if (_0x3d7483) {
        _0x1ae2c2.textContent = _0x3d7483;
      }
      _0x168eb9.forEach(_0x19f93f => {
        _0x19f93f.setAttribute("disabled", "disabled");
      });
      if (_0x36b277) {
        _0x36b277.classList.add("hidden");
      }
    } else {
      _0x2492d7.setAttribute("data-unavailable", "false");
      _0x1ae2c2.textContent = window.variantStrings.addToCart;
      if (_0x36b277) {
        _0x36b277.classList.remove("hidden");
      }
      if (_0x2492d7.dataset.requiredFields === _0x2492d7.dataset.validFields) {
        _0x2492d7.removeAttribute("disabled");
        _0x168eb9.forEach(_0x3a44de => {
          _0x3a44de.removeAttribute("disabled");
        });
      }
    }
    if (!_0x300975) {
      return;
    }
  }
  setUnavailable() {
    const _0x47677c = document.getElementById("product-form-" + this.dataset.section);
    if (!_0x47677c) {
      return;
    }
    const _0x111390 = _0x47677c.querySelector("[name=\"add\"]");
    var _0x3be5b7 = _0x47677c.querySelector(".main-atc__label__text");
    if (!_0x3be5b7) {
      _0x3be5b7 = _0x47677c.querySelector(".main-atc__label");
    }
    const _0x5560e8 = document.getElementById("price-" + this.dataset.section);
    const _0x104ba5 = document.getElementById("Inventory-" + this.dataset.section);
    const _0x596c26 = document.getElementById("Sku-" + this.dataset.section);
    if (!_0x111390) {
      return;
    }
    _0x3be5b7.textContent = window.variantStrings.unavailable;
    if (_0x5560e8) {
      _0x5560e8.classList.add("visibility-hidden");
    }
    if (_0x104ba5) {
      _0x104ba5.classList.add("visibility-hidden");
    }
    if (_0x596c26) {
      _0x596c26.classList.add("visibility-hidden");
    }
  }
  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector("[type=\"application/json\"]").textContent);
    return this.variantData;
  }
}
customElements.define("variant-selects", VariantSelects);
class SecondaryVariantSelect extends VariantSelects {
  constructor() {
    super();
    this.secondarySelectSelector = "variant-selects-";
    this.secondarySelect = document.getElementById("" + this.secondarySelectSelector + this.dataset.section);
    this.isSecondary = true;
  }
  updateOptions() {
    this.options = this.querySelector("select").value.split(",");
  }
}
customElements.define("secondary-variant-select", SecondaryVariantSelect);
class SecondaryVariantSelectSeparate extends VariantSelects {
  constructor() {
    super();
    this.secondarySelectSelector = "variant-selects-";
    this.secondarySelect = document.getElementById("" + this.secondarySelectSelector + this.dataset.section);
    this.isSecondary = true;
  }
}
customElements.define("secondary-variant-select-separate", SecondaryVariantSelectSeparate);
class CardVariantSelects extends VariantSelects {
  constructor() {
    super();
    this.quickAddSubmit = document.getElementById(this.dataset.section + "-submit");
  }
  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    this.updateVariantStatuses();
    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateVariantInput();
      this.updateQuickAddUrl();
      this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
    }
  }
  updateMedia() {
    if (!this.currentVariant || !this.currentVariant.featured_media) {
      return;
    }
    const _0x38bef6 = document.getElementById(this.dataset.section + "-image");
    if (!_0x38bef6) {
      return;
    }
    const _0x407dff = this.currentVariant.featured_media.preview_image;
    const _0x2bd7a7 = _0x407dff.src.split("?")[0];
    const _0x5273f6 = [165, 360, 533, 720, 940, 1066];
    const _0x52722c = _0x5273f6.filter(_0x463c44 => _0x407dff.width >= _0x463c44).map(_0x5a77f7 => _0x2bd7a7 + "?width=" + _0x5a77f7 + " " + _0x5a77f7 + "w").join(", ");
    _0x38bef6.srcset = _0x52722c + ", " + _0x2bd7a7 + " " + _0x407dff.width + "w";
    _0x38bef6.src = _0x2bd7a7 + "?width=533";
  }
  updateQuickAddUrl() {
    if (!this.currentVariant || !this.quickAddSubmit) {
      return;
    }
    this.quickAddSubmit.dataset.productUrl = this.dataset.url + "?variant=" + this.currentVariant.id;
  }
}
customElements.define("card-variant-selects", CardVariantSelects);